import React, { Component } from "react"
import AppPage from "../AppPage"
import LoadingIndicator from "../Loading/LoadingIndicator"
import EntryPointHOC from "../Contexts/EntryPointHOC"
import CartContextHOC from "../Contexts/CartContextHOC"
import UserContextHOC from "../Contexts/UserContextHOC"
import AnalyticsContextHOC from "../Contexts/AnalyticsContextHOC"
import CheckoutSelectPayment from "./CheckoutSelectPayment"
import Injection from "../Injection"
import { ErrorIcon } from "./CheckoutSelectPayment"
import { withRouter } from "react-router-dom"
import CartItems from "../Components/Cart/CartItemsCheckout"
import Checkbox from "../sparkles/Checkbox/Checkbox"
import Modal2 from "../Modal/Modal"
import KioskDinerDetails from "./KioskDinerDetails"
import GooglePlacesAutocomplete from "../GooglePlacesAutocomplete"
import withErrorHandling from "../Contexts/withErrorHandling/withErrorHandling"
import { Text, ButtonWrapper } from "../atoms"
import { injectStripe, Elements } from "react-stripe-elements"
import { ReactComponent as Close } from "../assets/icons/modal-close.svg"
import { ReactComponent as CurLoc } from "../assets/icons/cur-loc.svg"
import { ReactComponent as DeliveryIconChecker } from "../assets/icons/Delivery.svg"
import { ReactComponent as PickupIconChecker } from "../assets/icons/Pickup.svg"
import { ReactComponent as ApplePayLogo } from "./ApplePayLogo.svg"
import { ReactComponent as PickupIcon } from "./PickupIcon.svg"
import { ReactComponent as DeliveryIcon } from "./DeliveryIcon.svg"
import BitcoinCircle from "./BitcoinCircle"
import Switch from "react-switch"
import ReactTooltip from "react-tooltip"
import CouponInput from "../sparkles/CouponInput/CouponInputNew"
import Modal from "react-modal"
import TimeSelect from "../sparkles/TimeSelect/TimeSelectNew"
import extractAddressComponents from "../helpers/googlePlaces"
import QRCode from "react-qr-code"
import classnames from "classnames"
import "./Checkout.css"
import withWallet from "../withWallet"
//import { Token, TOKEN_PROGRAM_ID } from "@solana/spl-token";
import * as splToken from "@solana/spl-token"
import {
  Connection,
  PublicKey,
  Transaction,
  SystemProgram,
  sendAndConfirmTransaction,
} from "@solana/web3.js"
import { ConnectionStatus } from "capacitor-stripe-terminal"

const TREASURY_ADDRESS = process.env.REACT_APP_TREASURY_ADDRESS
const TREASURY_USDC_ADDRESS = process.env.REACT_APP_TREASURY_USDC_ADDRESS
const TREASURY_FOODCOIN_ADDRESS =
  process.env.REACT_APP_TREASURY_FOODCOIN_ADDRESS
const USDC_TOKEN_ADDRESS = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"
const FOODCOIN_TOKEN_ADDRESS = "B7vkWNFo2aYcYddtwR8fvDwY1Uc54wHfdTXULjrX7KeL"
const LAMPORTS_PER_SOL = 1000000000
const TOKEN_PROGRAM_ID = "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
const ASSOCIATED_TOKEN_PROGRAM_ID =
  "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"

window.RPC = process.env.REACT_APP_SOLANA_RPC_ENDPOINT
window.RPC2 = process.env.REACT_APP_SOLANA_RPC_ENDPOINT2

var cumulativeOffset = function (element) {
  var top = 0,
    left = 0
  do {
    top += element.offsetTop || 0
    left += element.offsetLeft || 0
    element = element.offsetParent
  } while (element)

  return {
    top: top,
    left: left,
  }
}
window.honey = cumulativeOffset

let checkForSolanaSuccess = function (signature, iteration, resolve, reject) {
  if (iteration >= 60) {
    resolve({ success: false, error: "timeout" })
    return
  }

  let payload = { signature: signature }
  api.callApi(
    "wait-for-solana-txn-confirm",
    (resp) => {
      console.log("check for resp", resp)
      if (resp.success) {
        resolve({ success: true })
      } else {
        setTimeout(
          () =>
            checkForSolanaSuccess(signature, iteration + 1, resolve, reject),
          1000
        )
      }
    },
    (error) => {
      console.log("check for error", error)
      reject(error)
    },
    payload
  )
}

let waitForTxnToConfirm = function (signature) {
  return new Promise(function (resolve, reject) {
    checkForSolanaSuccess(signature, 0, resolve, reject)
  })
}

Modal.setAppElement("#root")

const api = require("../helpers/api")
const Api = api
const Subdomain = require("../helpers/subdomain")
const formatPrice = require("../helpers/formatPrice")

const TIP_RATES_SMALL = [
  { percent: 0.15, amount: 300 },
  { percent: 0.2, amount: 400 },
  { percent: 0.25, amount: 500 },
]

const TIP_RATES_BIG = [
  { percent: 0.1, amount: 300 },
  { percent: 0.15, amount: 400 },
  { percent: 0.2, amount: 500 },
]

class Checkout extends Component {
  constructor(props) {
    super(props)
    window.checkout = this
    this.state = {
      loading: false,
      isMobile: window.innerWidth < 920,
      loading_gps: false,
      headerExpansion: null,
      address2:
        this.props.cart.confirmed_address &&
        this.props.cart.confirmed_address.address2
          ? this.props.cart.confirmed_address.address2
          : "",
      pickup_or_delivery: this.props.cart.pickup_or_delivery,
      tipAmounts: [100, 200, 300],
      tipRates: [],
      displayedAddress: null, // this value gets synced from the <GooglePlacesAutocomplete>
      zipcode: "",
      paymentError: null,
      desktopChangeExpanded: false,
      customTipAmount: "",
      customPaymentName: "",
      customPaymentNumber: "",
      utensils: true,
      splitTip: true,
      specialInstructions: null,
      deliveryInstructions: null,
      multiView: "review",
      eligibleForTaxExempt: null,
      taxExempt: false,
    }
    this.headerRowRef = React.createRef()
    this.specialInstructionRef = React.createRef()
    this.deliveryInstructionRef = React.createRef()
    this.mobileCartSectionRef = React.createRef()
    this.splitTipRef = React.createRef()
    this.lastSplitTipRef = false
    window.checkout = this
    this.closeModal = this.closeModal.bind(this)
    this.handleResize = this.handleResize.bind(this)
    this.editCart = this.editCart.bind(this)
    this.updateParent = this.updateParent.bind(this)
    this.setLoading = this.setLoading.bind(this)
    this.unsetLoading = this.unsetLoading.bind(this)
    this.timeSelectRef = React.createRef()
    this.googlePlacesAutocompleteRef = React.createRef()
    this.orderTypeDropdownRef = React.createRef()
    this.timeSelectDropdownRef = React.createRef()
    this.customTipInputRef = React.createRef()
    this.checkoutSelectPaymentRef = React.createRef()
    this.paymentSectionRef = React.createRef()
    this.contactSectionRef = React.createRef()
    this.detailSectionRef = React.createRef()
    this.desktopCartRef = React.createRef()
    this.hiddenRightSideRef = React.createRef()
    this.streetAddressRef = React.createRef()

    if (this.props.cart.initial_address) {
      this.props.cart.setConfirmedAddress(
        JSON.parse(JSON.stringify(this.props.cart.initial_address))
      )
      this.state["addressObj"] = this.props.cart.confirmed_address
      this.props.analytics.debug(
        "Checkout-- got initial address",
        JSON.stringify(this.props.cart.initial_address)
      )
    }

    const browser = this.props.analytics.browser()
    const utms = this.props.analytics.utms()
    const versionId = this.props.analytics.versionId()
    const sessionId = this.props.analytics.sessionId()
    this.props.cart.setBrowser(browser)
    this.props.cart.setUTMs(utms)
    this.props.cart.setVersion(versionId)
    this.props.cart.setSessionId(sessionId)
    window.scroll(0, 0)
  }

  componentDidMount() {
    this.checkForTaxExemptEligibility()
    this.props.analytics.info("CheckoutPageLoaded")
    this.props.cart.getCoinBalances()
    this.getSolanaPrice()
    window.addEventListener("resize", this.handleResize)
    this.setState({ mounted: true })
    this.setTipRatesAndDefaultTip()
    // there are some edge cases where the user can
    // end up here without a phone number. if this happens
    // need to force the phone number collection modal
    if (this.props.user.user && !this.props.user.user.phone_number_e164) {
      if (this.props.user.user.phone_number) {
        this.props.analytics.debug(
          "CheckoutNoPhone164nutHasPhoneNotSendingBack"
        )
        return
      }
      this.props.analytics.debug("CheckoutNoPhoneSendBack")
      let pathname = "/menu/phone_verify?sendTo=checkout"
      this.props.history.push({ pathname: pathname })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // handle edge cases to send back if no phone
    if (
      !prevProps.user.user &&
      this.props.user.user &&
      !this.props.user.user.phone_number_e164
    ) {
      this.props.analytics.debug("CheckoutNoPhoneSendBack")
      let pathname = "/menu/phone_verify?sendTo=checkout"
      this.props.history.push({ pathname: pathname })
    }

    if (!prevProps.cart.initial_address && this.props.cart.initial_address) {
      this.setState({ addressObj: this.props.cart.initial_address })
      this.props.cart.setConfirmedAddress(
        JSON.parse(JSON.stringify(this.props.cart.initial_address))
      )
      this.props.analytics.debug(
        "Checkout-- got initial address from update",
        JSON.stringify(this.props.cart.initial_address)
      )
    }

    if (
      !this.state.pickupOrDelivery &&
      !prevProps.cart.pickup_or_delivery &&
      this.props.cart.pickup_or_delivery
    ) {
      this.setState({ pickup_or_delivery: this.props.cart.pickup_or_delivery })
    }

    // make sure that we set the utms properly, especially if
    // coming in from outside the context and pulling this from
    // localstorage in the analytics object
    if (
      JSON.stringify(prevProps.cart.utms) !==
      JSON.stringify(this.props.analytics.utms())
    ) {
      const utms = this.props.analytics.utms()
      this.props.cart.setUTMs(utms)
    }

    if (
      prevProps.cart.pickup_or_delivery === "pickup" &&
      this.props.cart.pickup_or_delivery === "delivery"
    ) {
      this.setTipRatesAndDefaultTip(true)
    }

    if (
      JSON.stringify(prevProps.cart.finance) !==
      JSON.stringify(this.props.cart.finance)
    ) {
      ReactTooltip.rebuild()
    }

    if (this.splitTipRef.current && !this.lastSplitTipRef) {
      ReactTooltip.rebuild()
    }

    this.lastSplitTipRef = !!this.splitTipRef.current
  }

  rebuild() {
    ReactTooltip.rebuild()
  }

  checkForTaxExemptEligibility() {
    if (!this.props.rest.rest_id || !this.props.user.user) {
      setTimeout(() => this.checkForTaxExemptEligibility(), 100)
      return
    }
    let params = {
      rest_uuid: this.props.rest.rest_id,
      diner_uuid: this.props.user.user.uniq_uuid,
    }
    Api.callApi(
      "is-tax-exempt",
      (data) => {
        this.setState({ taxExemptEligible: data.tax_exempt })
      },
      (err) => {
        console.log(err)
      },
      params
    )
  }

  getSolanaPrice() {
    api.callApi(
      "solana-price",
      (resp) => {
        this.setState({
          solPrice: resp.cents,
          sol_uuid: resp.uuid,
        })
        window.sol_price_uuid = resp.uuid
      },
      (err) => {
        console.log("error", err)
      }
    )
  }

  shouldShowTips() {
    if (!this.state.tipRates.length) return false
    if (this.props.cart.cash) return false
    if (
      this.props.rest.allowPickupTips === false &&
      this.props.cart.pickup_or_delivery === "pickup"
    )
      return false

    return true
  }

  tipAmounts() {
    if (!this.state.tipRates) return null
    let usePercent = this.usePercent()
    let subtotal = this.props.cart.subtotal()
    let amounts = []
    for (var i in this.state.tipRates) {
      if (usePercent) {
        amounts.push(Math.round(this.state.tipRates[i].percent * subtotal))
      }
    }
  }

  usePercent() {
    return this.props.cart.subtotal() > 2000
  }

  setTipRatesAndDefaultTip(setTip = false) {
    if (
      !this.props.cart.isFinanceLoaded() ||
      !this.props.cart.isPickupOrDeliveryLoaded()
    ) {
      setTimeout(() => this.setTipRatesAndDefaultTip(), 100)
      return false
    }
    var rates = 0

    if (this.props.cart.subtotal() >= 4000) {
      rates = TIP_RATES_BIG
    } else {
      rates = TIP_RATES_SMALL
    }

    //only set the default tip for delivery
    var defaultAmount = 0
    if (this.props.cart.pickup_or_delivery === "delivery") {
      if (this.usePercent()) {
        defaultAmount = parseInt(
          rates[1].percent * this.props.cart.subtotal(),
          10
        )
      } else {
        defaultAmount = rates[1].amount
      }
    } else {
      //set pickup to 0 for default
      defaultAmount = 0
    }

    this.setState({ tipRates: rates }, () => console.log("done setting rates"))

    //if the page has beeen reloaded, dont re-select the default tip
    if (
      (!this.props.cart.finance.tipSelected || setTip) &&
      !this.props.cart.cash
    ) {
      this.props.cart.setTip(defaultAmount)
    }
  }

  capitalize(str) {
    if (!str) return
    return str[0].toUpperCase() + str.substring(1)
  }

  handleResize() {
    this.props.analytics.debug("CheckoutHandlingResize", window.innerWidth)
    this.setState({
      isMobile: window.innerWidth < 920,
    })
  }

  closeModal() {
    this.props.analytics.debug("CheckingCloseModal")
    this.setState({
      headerExpansion: null,
      desktopChangeExpanded: false,
      pickup_or_delivery: this.props.cart.pickup_or_delivery,
    })
  }

  setLoading() {
    this.props.analytics.debug("CheckoutSetLoading")
    this.setState({ loading: true })
  }

  unsetLoading() {
    this.props.analytics.debug("CheckoutUnsetetLoading")
    this.setState({ loading: false })
  }

  updateParent(formattedAddress) {
    this.setState({ displayedAddress: formattedAddress })
  }

  headerRowModalStyle() {
    if (this.state.isMobile && this.headerRowRef.current) {
      let _top =
        this.headerRowRef.current.offsetTop +
        this.headerRowRef.current.offsetHeight
      let style = {
        display: "block",
        position: "fixed",
        top: _top + "px",
      }
      if (this.state.addressFocused) {
        style["position"] = "absolute"
        style["paddingBottom"] = "300px"
      }
      // some hackery to deal with scrolling on landscape view
      if (window.innerWidth > window.innerHeight) {
        style["overflowY"] = "scroll"
        style["bottom"] = "0px"
        style["paddingBottom"] = "70px"
      }
      return style
    }
  }

  editCart() {
    this.props.analytics.info("CheckoutEditCartLink")
    this.props.history.push({ pathname: "/menu" })
    window.scrollTo(0, 0)
  }

  contentStyle() {
    if (this.state.headerExpansion) {
      return {
        opacity: 0.5,
      }
    }
  }

  geocodeSelect(addressObj) {
    this.props.analytics.info(
      "CheckoutGeocodeSelect",
      JSON.stringify(addressObj)
    )
    if (!addressObj["address1"]) {
      this.props.analytics.info(
        "CheckoutBadAddress",
        JSON.stringify(addressObj)
      )
      this.props.updateError(
        true,
        "Sorry, we can't find your address - please select one from the dropdown.",
        true,
        { zIndex: "1000", position: "fixed", top: "0", width: "99vw" }
      )
      this.setState({ addressObj: null })
      return
    }
    this.props.updateError(false)
    this.setState({ addressObj: addressObj })
  }

  currentLocation() {
    this.props.analytics.info("CheckoutCurrentLocation")
    this.setState({ loading_gps: true })
    navigator.geolocation.getCurrentPosition(
      this.currentLocationSuccess.bind(this),
      this.currentLocationError.bind(this)
    )
  }

  currentLocationSuccess(position) {
    this.props.analytics.info(
      "CheckoutCurrentLocationSuccess",
      JSON.stringify(position)
    )
    this.setState(
      {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
        loading_gps: false,
      },
      () =>
        api.callApi(
          "reverse_geocode",
          this.reverseGeocodeSuccess.bind(this),
          this.reverseGeocodeFail.bind(this),
          null,
          position.coords
        )
    )
  }

  reverseGeocodeSuccess(data) {
    this.props.analytics.info(
      "CheckoutReverseGeocodeSuccess",
      JSON.stringify(data)
    )

    var components = extractAddressComponents(data.address_components)
    if (!components["address1"]) {
      this.setState({ loading_gps: false })
      this.props.updateError(
        true,
        "Sorry, we can't find your address - please select one from the dropdown!",
        true,
        { zIndex: "1000", position: "fixed", top: "0", width: "99vw" }
      )
      return
    }
    this.props.analytics.debug("GPSSuccess", components["address1"])
    this.props.updateError(false)
    this.googlePlacesAutocompleteRef.current.setState({
      formattedAddress: data.formatted_address,
    })
    let addressObj = {
      lat: this.state.lat,
      lng: this.state.lng,
      formattedAddress: data.formatted_address,
      ...components,
    }
    this.setState({
      addressObj: addressObj,
      loading_gps: false,
      displayedAddress: data.formatted_address,
    })
  }

  reverseGeocodeFail(data) {
    this.props.analytics.info(
      "CheckoutReverseGeocodeFail",
      JSON.stringify(data)
    )
    this.setState({ loading_gps: false, geocoded_address: "geocode fail" })
  }

  currentLocationError() {
    this.props.analytics.info("CheckerPageGPSNoPermission")
    this.props.updateError(
      true,
      "Oops! Looks like you have Location Services blocked for this browser. To use the Current Location feature, please enable Location Services in your device's settings.",
      true,
      { zIndex: "1000", position: "fixed", top: "0", width: "99vw" }
    )
    this.setState({ loading_gps: false })
  }

  handleAddressBackspace() {
    let address = ""
    if (this.state.addressObj) {
      address = this.state.addressObj["formattedAddress"]
    }
    this.setState({ addressObj: { formattedAddress: address } })
  }

  clearAddress() {
    this.googlePlacesAutocompleteRef.current.setState({ formattedAddress: "" })
    this.setState({
      addressObj: null,
      displayedAddress: null,
      errorMessage: null,
    })
    this.props.updateError(false)
  }

  renderButton(type) {
    let isPickupOpen = this.props.rest.hours.pickup.open
    let isDeliveryOpen = this.props.rest.hours.delivery.open
    let rest = this.props.rest
    let hours = rest.hours
    let override = true

    if (type === "pickup") {
      //If its open, show address
      if (isPickupOpen || override) {
        return (
          <>
            <Text size="s" as="span">
              {rest.address}
            </Text>
            <Text size="s" as="span">
              {rest.city}, {rest.state} {rest.zipcode}
            </Text>
          </>
        )
      } else {
        return !this.props.rest.checkIfFuturePickupAvailable() ? (
          <Text size="s" weight="bold">
            Currently Unavailable
          </Text>
        ) : (
          <>
            <Text size="s" as="span">
              {rest.address}
            </Text>
            <Text size="s" as="span">
              {rest.city}, {rest.state} {rest.zipcode}
            </Text>
          </>
        )
      }
    } else {
      if (isDeliveryOpen) {
        return (
          <div className="mt-2">
            <Text size="s">{`Est. Time ${rest.default_delivery_time} min`}</Text>
            <Text size="s">{`Open Until ${hours.delivery.close_time}`}</Text>
          </div>
        )
      } else {
        let text = this.props.rest.checkIfFutureDeliveryAvailable()
          ? "Order for Later at an available time"
          : "Currently Unavailable"

        return (
          <Text size="s" weight="bold">
            {text}
          </Text>
        )
      }
    }
  }

  handleDeliveryOrPickup(type) {
    this.setState({ pickup_or_delivery: type })
  }

  showPaymentError(msg) {
    if (this.state.isMobile && this.headerRowRef.current) {
      this.setState({ paymentError: msg }, () => {
        let _top =
          this.headerRowRef.current.offsetTop +
          this.headerRowRef.current.offsetHeight
        window.scrollTo(
          0,
          cumulativeOffset(this.paymentSectionRef.current).top - _top
        )
      })
    } else {
      this.setState({ paymentError: msg }, () => {
        window.scrollTo(
          0,
          cumulativeOffset(this.paymentSectionRef.current).top - 70
        )
      })
    }
  }

  placeOrderSuccess(data) {
    this.props.analytics.debug("PlaceOrderResponse", JSON.stringify(data))
    this.props.cart.setSolanaTxn(null)
    this.setState({ loading: false })
    if (data.error) {
      if (data.error_type === "payment") {
        this.props.analytics.info(
          "PlaceOrderPaymentFailure",
          data.error_message
        )
        this.showPaymentError(data.error_message)
        return
      } else if (data.error_type === "coupon") {
        this.props.analytics.info("PlaceOrderFailureCoupon", data.message)
        alert(data.message)
        return
      } else if (data.error_type === "invalid_future_order_time") {
        this.props.analytics.info("PlaceOrderFailureFutureOrderTime")
        this.props.cart.setFutureOrderTime(null)
        alert(data.message)
        window.location.href = "/"
      } else if (data.error_type === "custom_payment") {
        this.showPaymentError(data.message)
        this.props.analytics.info("PlaceOrderFailureInvalidCart", data.message)
        return
      } else if (data.error_type == "delivery_fee_mismatch") {
        this.reverifyDeliveryZone(() =>
          alert("There was en error. Please try placing your order again.")
        )
        return
      } else if (data.error_type === "invalid_cart") {
        this.props.analytics.info("PlaceOrderFailureInvalidCart", data.message)
        if (this.state.isMobile) {
          let _top =
            this.headerRowRef.current.offsetTop +
            this.headerRowRef.current.offsetHeight
          this.setState(
            {
              cartError: data.message,
            },
            () =>
              window.scrollTo(
                0,
                this.mobileCartSectionRef.current.offsetTop - _top
              )
          )
        } else {
          this.setState({
            cartError: data.message,
          })
          window.scrollTo(0, 0)
        }
        return
      } else {
        window.scrollTo(0, 0)
        if (data.message) alert(data.message)
        return
      }
    }
    this.props.analytics.info("PlaceOrderSuccess", data.hash_id)
    this.props.analytics.conversion(data.hash_id, data.total)
    this.props.cart.emptyCart()
    if (data.opennode_charge_id) {
      window.location.href =
        "https://checkout.opennode.com/" + data.opennode_charge_id
      return
    } else {
      //let url = `/thankyou?hash_id=${data.hash_id}&diner_id=${this.props.user.user.uniq_uuid}`
      let search = `?hash_id=${data.hash_id}&diner_id=${this.props.user.user.uniq_uuid}`
      this.props.history.replace({
        pathname: "thankyou",
        search: search,
      })
    }
  }

  placeOrderError(data) {
    this.props.analytics.info("PlaceOrderFailure", JSON.stringify(data))
    this.props.cart.setSolanaTxn(null)
    this.props.updateError(
      true,
      "There has been a problem, please try again or contact the restaurant.",
      true,
      { zIndex: "1000", position: "fixed", top: "0", width: "99vw" }
    )
    this.setState({ loading: false })
  }

  async getKioskPaymentIntent() {
    const displayMessages = {
      1: "Insert the presented card.",
      2: "Insert or swipe the presented card.",
      5: "The reader detected multiple contactless cards. Make sure only one contactless card or NFC device is near the reader.",
      4: "Remove the presented card.",
      0: "Retry the presented card.",
      3: "Swipe the presented card.",
      7: "The card is invalid. Try another card.",
      6: "The card could not be read. Try another read method on the same card, or use a different card.",
    }

    const displaySubscription = window.terminal
      .didRequestReaderDisplayMessage()
      .subscribe((displayMessage) => {
        this.setState({ kioskDisplayMessage: displayMessages[displayMessage] })
      })
    const inputSubscription = window.terminal
      .didRequestReaderInput()
      .subscribe((inputOptions) => {
        //alert(inputOptions)
      })

    Api.callApi(
      "kiosk-create-payment-intent",
      async (data) => {
        let clientSecret = data.client_secret
        let paymentIntentId = data.payment_intent_id
        this.props.cart.setKioskPaymentIntentId(paymentIntentId)

        try {
          await window.terminal.cancelCollectPaymentMethod()
        } catch (err) {
          console.log(err)
        }

        await window.terminal.retrievePaymentIntent(clientSecret)
        this.setState({ kioskModal: "ready_for_payment" })
        this.collectingPayment = true

        await window.terminal.collectPaymentMethod()
        this.collectingPayment = false
        try {
          await window.terminal.processPayment()
          this.setState({ koiskModal: "loading" })
          this.submitKioskOrder(paymentIntentId)
        } catch (err) {
          this.setState({ kioskModal: "error", kioskError: err })
        }
      },
      (err) => {
        console.log(err)
      },
      { total: this.props.cart.finance.total, rest_id: this.props.rest.rest_id }
    )
  }

  submitKioskOrder(paymentIntentId) {
    const diner_id = this.props.user.user.uniq_uuid
    this.props.cart.invokeOrderPlacement(
      diner_id,
      (data) => {
        if (data.error) {
          this.setState({ kioskModal: null })
          if (data.error_type === "payment") {
            this.props.analytics.info(
              "PlaceOrderPaymentFailure",
              data.error_message
            )
            this.showPaymentError(data.error_message)
            return
          } else if (data.error_type === "coupon") {
            this.props.analytics.info("PlaceOrderFailureCoupon", data.message)
            alert(data.message)
            return
          } else if (data.error_type === "invalid_future_order_time") {
            this.props.analytics.info("PlaceOrderFailureFutureOrderTime")
            this.props.cart.setFutureOrderTime(null)
            alert(data.message)
            window.location.href = "/"
          } else if (data.error_type === "custom_payment") {
            this.showPaymentError(data.message)
            this.props.analytics.info(
              "PlaceOrderFailureInvalidCart",
              data.message
            )
            return
          } else if (data.error_type == "delivery_fee_mismatch") {
            this.reverifyDeliveryZone(() =>
              alert("There was en error. Please try placing your order again.")
            )
            return
          } else if (data.error_type === "invalid_cart") {
            this.props.analytics.info(
              "PlaceOrderFailureInvalidCart",
              data.message
            )
            if (this.state.isMobile) {
              let _top =
                this.headerRowRef.current.offsetTop +
                this.headerRowRef.current.offsetHeight
              this.setState(
                {
                  cartError: data.message,
                },
                () =>
                  window.scrollTo(
                    0,
                    this.mobileCartSectionRef.current.offsetTop - _top
                  )
              )
            } else {
              this.setState({
                cartError: data.message,
              })
              window.scrollTo(0, 0)
            }
            return
          }
        } // <-- if data.error

        this.props.cart.emptyCart()
        this.setState({ kioskModal: "placed", order: data }, () =>
          setTimeout(() => (window.location.href = "/"), 30000)
        )
      },

      (err) => {
        alert("ERROR PLACING ORDER")
      }
    )
  }

  /* submitOrderForProcessing - begins the process of submitting the
     order for processing, which is a BLOCKING call. in the mean time,
     disable the submit button from being pressed twice and then make
     a call to the /api/order/place API, which in the event of success
     will forward the user to a THANKYOU page */
  async submitOrderForProcessing() {
    this.props.analytics.debug("CheckoutSubmitOrderForProcessing")

    // if we're in kiosk mode, then now we need to pop up a modal
    if (window.KIOSK_MODE) {
      if (!this.props.cart.kioskDinerDetails.firstName) {
        if (this.contactSectionRef && this.contactSectionRef.current) {
          window.scrollTo(
            0,
            cumulativeOffset(this.contactSectionRef.current).top - 70
          )
        }
        alert("Please enter your first name")
        return
      }

      let isConnected = await window.terminal.getConnectionStatus()
      if (isConnected !== ConnectionStatus.Connected) {
        alert(
          "The credit card reader is offline. This order can not be processed"
        )
        return
      }
      this.getKioskPaymentIntent()
      this.setState({ kioskModal: "loading", kioskDisplayMessage: null })
      return
    }

    if (
      this.props.cart.supperclubApplied > 0 ||
      this.props.cart.supperclubPromoApplied > 0
    ) {
      this.setState({ loading: true })
      try {
        let result = await this.sendSupperClubPayment(
          this.props.cart.finance.total
        )
        if (!result.success) {
          this.setState({ loading: false })
          this.props.updateError(
            true,
            "Unkown Supper Club wallet error. Please try again.",
            true,
            { zIndex: "1000", position: "fixed", top: "0", width: "99vw" }
          )

          return
        }
      } catch (err) {
        console.log("err", err)
        this.setState({ loading: false })
        this.props.updateError(
          true,
          "Unkown Supper Club wallet error. Please try again",
          true,
          { zIndex: "1000", position: "fixed", top: "0", width: "99vw" }
        )

        return
      }
    }

    if (this.props.cart.sol && !this.props.cart.qr) {
      this.setState({ loading: true })
      try {
        let result = await this.sendTransaction()
        if (!result.success) {
          this.setState({ loading: false })
          this.showPaymentError(
            "Unkown error. Please try again or choose a different payment method"
          )
          return
        }
      } catch (err) {
        console.log("err", err)
        this.setState({ loading: false })
        this.showPaymentError(
          "Unkown error. Please try again or choose a different payment method"
        )
        return
      }
    }

    if (this.props.cart.sol && this.props.cart.qr) {
      if (!this.props.cart.solanaTxn) {
        this.startQRSession()
        this.setState({ solanaPayQR: true })
        return
      }
    }

    if (this.props.rest.isLocked()) {
      if (!this.props.cart.tableNumber) {
        this.props.analytics.info("CheckoutLockedRestNoTableNumber")
        this.props.updateError(true, "Please enter your table number.", null, {
          position: "absolute",
          top: "51px",
          width: "100%",
          zIndex: 10,
          boxSizing: "border-box",
        })
        window.scrollTo(0, 0)
        return
      } else if (this.props.cart.tableNumber.match(/^[0-9]+$/) === null) {
        this.props.analytics.info(
          "CheckoutLockedRestInvalidTableNumber",
          this.props.cart.tableNumber
        )
        this.props.updateError(
          true,
          "Please enter a valid table number.",
          null,
          {
            position: "absolute",
            top: "51px",
            width: "100%",
            zIndex: 10,
            boxSizing: "border-box",
          }
        )
        window.scrollTo(0, 0)
        return
      }
    }

    let cartOrderPlacement = () => {
      this.props.analytics.debug("CheckoutCartOrderPlacement")
      this.setState({ loading: true })
      this.props.cart.stillAcceptingOrders((accepting_orders) => {
        if (
          accepting_orders.accepting_orders ||
          this.props.cart.futureOrderTime
        ) {
          const onSuccess = this.placeOrderSuccess.bind(this)
          const onFailure = this.placeOrderError.bind(this)

          const diner_id = this.props.user.user.uniq_uuid

          this.props.analytics.info(
            "InvokingOrderPlacement",
            `DinerId-${diner_id}`
          )
          this.props.cart.invokeOrderPlacement(diner_id, onSuccess, onFailure)
        } else {
          this.props.analytics.info("PlaceOrderPrevented", "Restaurant closed")
          alert("Sorry, the restaurant has closed.")
          this.setState({ loading: false })
        }
      })
    }

    // if using a saved card
    if (this.props.cart.savedCard) {
      this.props.analytics.debug(
        "CheckoutAboutToPlaceOrderUsingSavedCard",
        JSON.stringify(this.props.cart.savedCard)
      )
      cartOrderPlacement()
    } else if (this.props.cart.applePay) {
      this.props.analytics.debug("CheckoutAboutToPaymentRequestApplePay")
      const paymentRequest = this.props.stripe.paymentRequest({
        country: "US",
        currency: "usd",
        total: {
          label: this.props.rest.name,
          amount: this.props.cart.finance.total,
        },
      })
      paymentRequest.on("token", (resp) => {
        this.props.cart.setStripeToken(resp.token.id, resp.token.card, () =>
          cartOrderPlacement()
        )
        resp.complete("success")
      })

      paymentRequest.on("cancel", () => {
        this.props.analytics.info("CheckoutCancelApplePayPaymentRequest")
        this.setState({ loading: false })
      })

      paymentRequest
        .canMakePayment()
        .then((result) => {
          paymentRequest.show()
        })
        .catch((err) => {
          this.setState({ loading: false })
          this.props.analytics.info(
            "CheckoutApplePayError",
            JSON.stringify(err)
          )
        })
    } else if (this.props.cart.cash) {
      this.props.analytics.debug("CheckoutAboutToPlaceOrderCash")
      cartOrderPlacement()
    } else if (this.props.cart.bitcoin) {
      this.props.analytics.debug("CheckoutAboutToPlaceBitcoin")
      cartOrderPlacement()
    } else if (this.props.cart.sol) {
      this.props.analytics.debug("CheckoutAboutToPlaceSolana")
      cartOrderPlacement()
    } else if (this.props.cart.customPayment) {
      this.props.analytics.debug("CheckoutAboutToPlaceOrderCustomPayment")
      cartOrderPlacement()
    } else if (
      this.props.cart.finance.total === 0 &&
      this.props.cart.finance.promo > 0
    ) {
      this.props.analytics.debug("CheckingOutWithZeroDollarsAndPromo")
      cartOrderPlacement()
    }
    // else if supperclub balance covers the only thing we should do
    // cartOrderPlacementm
    else if (
      this.props.cart.supperclubWallet &&
      this.props.cart.remainingBalance === 0
    ) {
      this.props.analytics.debug("CheckingOutWithAllCoins")
      cartOrderPlacement()
    } else {
      this.props.analytics.debug("CheckoutAbotToPlaceOrderNewCard")
      this.setState({ loading: true })
      // PAT
      let { token, error } = await this.props.stripe.createToken({
        address_zip: this.state.zipcode,
      })
      if (token) {
        this.props.analytics.debug("CheckoutAbotToPlaceOrderNewCardGotToken")
        this.props.cart.setStripeToken(token.id, token.card, () =>
          cartOrderPlacement()
        )
      } else {
        this.setState({ loading: false })
        this.props.analytics.debug(
          "CheckoutAbotToPlaceOrderNewCardError",
          JSON.stringify(error)
        )
        this.showPaymentError(error.message)
      }
    }
  }

  renderCheckerPageStuff() {
    if (!this.props.rest.hours) return
    let rest = this.props.rest
    let hours = rest.hours
    let isPickupOpen = this.props.rest.hours.pickup.open
    let isDeliveryOpen = this.props.rest.hours.delivery.open
    let override = true
    const isPickupClosedEarly = hours.pickup.tablet_close_early && !override
    const isDeliveryClosedEarly = hours.delivery.tablet_close_early && !override

    return (
      <div>
        {this.state.isMobile && (
          <div style={{ textAlign: "right", width: "100%" }}>
            <span
              onClick={this.closeModal}
              style={{
                padding: "15px",
                display: "inline-block",
                position: "relative",
                right: "-14px",
              }}
            >
              <Close aria-label="Close modal" />
            </span>
          </div>
        )}
        <div className="deliveryButtonContainer">
          <ButtonWrapper
            withBorder
            onClick={() => this.handleDeliveryOrPickup("pickup")}
            className={classnames("checkout__action-button", {
              "checkout__action-button--selected":
                this.state.pickup_or_delivery === "pickup",
              "checkout__action-button--deactivated":
                !isPickupOpen && !rest.checkIfFuturePickupAvailable(),
            })}
          >
            <PickupIconChecker
              width={20}
              height={20}
              className={classnames("checkout__icon mb-2", {
                "checkout__icon--selected":
                  this.state.pickup_or_delivery === "pickup",
                "checkout__icon--deactivated":
                  isPickupClosedEarly && !rest.checkIfFuturePickupAvailable(),
              })}
            />
            <Text weight="black">Pickup</Text>
            <div className="mt-2 flex-col flex-justify-end flex-1 left">
              {this.renderButton("pickup")}
            </div>
            {(isPickupOpen || rest.checkIfFuturePickupAvailable()) && (
              <span className="checkout__action-button-circle" />
            )}
          </ButtonWrapper>
          <ButtonWrapper
            withBorder
            style={{
              "--button-border": rest.hex_color_primary,
            }}
            onClick={() => this.handleDeliveryOrPickup("delivery")}
            className={classnames("checkout__action-button", {
              "checkout__action-button--selected":
                this.state.pickup_or_delivery === "delivery",
              "checkout__action-button--deactivated":
                !isDeliveryOpen && !rest.checkIfFutureDeliveryAvailable(),
            })}
          >
            <DeliveryIconChecker
              height={25}
              width={30}
              className={classnames("checker__icon mb-2", {
                "checkout__icon--selected":
                  this.state.pickup_or_delivery === "delivery",
                "checkout__icon--deactivated":
                  isDeliveryClosedEarly &&
                  !rest.checkIfFutureDeliveryAvailable(),
              })}
            />
            <Text weight="black">Delivery</Text>
            <div className="mt-auto left">{this.renderButton("delivery")}</div>
            {(isDeliveryOpen || rest.checkIfFutureDeliveryAvailable()) && (
              <span className="checkout__action-button-circle" />
            )}
          </ButtonWrapper>
        </div>
      </div>
    )
  }

  renderLocationButton() {
    if (this.isAddressEntered()) {
      return (
        <ButtonWrapper
          className={classnames("curLoc")}
          onClick={() => this.clearAddress()}
          style={{ background: this.props.rest.hex_color_primary }}
        >
          <Close
            aria-label="clear address"
            className="buttonImg curLocImg"
            fill="white"
          />
        </ButtonWrapper>
      )
    } else {
      return (
        <button
          className={classnames("curLoc", {
            spin: this.state.loading_gps,
          })}
          onClick={() => this.currentLocation()}
          style={{ background: this.props.rest.hex_color_primary }}
        >
          <CurLoc className="buttonImg curLocImg" />
        </button>
      )
    }
  }

  // the answer is yes if the googleref has anything set for
  // formatted address
  isAddressEntered = () => {
    return this.state.displayedAddress
    if (this.googlePlacesAutocompleteRef.current) {
      return this.googlePlacesAutocompleteRef.current.state.formattedAddress
    } else {
      return false
    }
  }

  verifyDeliveryZone(addressObj) {
    this.setState({ loading: true })
    this.props.analytics.info(
      "CheckoutVerifyDeliveryZone",
      JSON.stringify(addressObj)
    )

    var payload = {
      fulfill_order_at: this.props.cart.futureOrderTime,
      lat: addressObj.lat,
      lng: addressObj.lng,
      formatted_address: addressObj.formattedAddress,
      subdomain: Subdomain.getSubdomain(),
      fulfill_order_at: this.timeSelectRef.current.state.time,
    }

    this.props.analytics.info(
      "CheckoutVerifyDeliveryZonePayload",
      JSON.stringify(payload)
    )
    api.callApi(
      "delivery_zone_verify",
      (resp) => {
        this.setState({ loading: false })
        if (resp.success) {
          this.props.analytics.info(
            "CheckoutVerifyDeliveryZoneSuccess",
            JSON.stringify(resp)
          )
          this.setState({ addressObj: addressObj })
          this.props.cart.setDeliveryZone(resp.delivery_zone)
          this.props.cart.setInitialAddress(addressObj)
          this.timeSelectRef.current.saveToCart()
          this.props.cart.setDeliveryNew()

          let address = addressObj
          address["address2"] = this.state.address2
          this.props.cart.setConfirmedAddress(address)
          this.setState({
            headerExpansion: null,
            addressObj: addressObj,
            desktopChangeExpanded: false,
          })
          setTimeout(() => ReactTooltip.rebuild(), 1000)
        } else {
          this.setState({ address2: "", errorMessage: resp.message })
          this.props.analytics.info(
            "CheckoutVerifyDeliveryZoneFail",
            JSON.stringify(resp)
          )
          this.props.updateError(true, resp.message, true, {
            zIndex: "1000",
            position: "fixed",
            top: "0",
            width: "99vw",
          })
        }
      },
      (error) => {
        this.setState({ loading: false })
        this.props.analytics.info("CheckoutVerifyDeliveryZoneError", error)
        this.props.updateError(true, "Server error.", true, {
          zIndex: "1000",
          position: "fixed",
          top: "0",
          width: "99vw",
        })
        this.clearAddress()
      },
      payload
    )
  }

  // called after a delivery fee mismatch
  reverifyDeliveryZone(callback) {
    this.setState({ loading: true })
    this.props.analytics.info("CheckoutReVerifyDeliveryZone")

    var payload = {
      fulfill_order_at: this.props.cart.futureOrderTime,
      lat: this.props.cart.confirmed_address.lat,
      lng: this.props.cart.confirmed_address.lng,
      subdomain: Subdomain.getSubdomain(),
    }

    api.callApi(
      "delivery_zone_verify",
      (resp) => {
        this.setState({ loading: false })
        if (resp.success) {
          this.props.cart.setDeliveryZone(resp.delivery_zone, callback)
          setTimeout(() => ReactTooltip.rebuild(), 1000)
        } else {
          this.setState({ address2: "" })
          this.props.analytics.info(
            "CheckoutVerifyDeliveryZoneFail",
            JSON.stringify(resp)
          )
          this.props.updateError(true, resp.message, true, {
            zIndex: "1000",
            position: "fixed",
            top: "0",
            width: "99vw",
          })
        }
      },
      (error) => {
        this.setState({ loading: false })
        this.props.analytics.info("CheckoutVerifyDeliveryZoneError", error)
        this.props.updateError(true, "Server error.", true, {
          zIndex: "1000",
          position: "fixed",
          top: "0",
          width: "99vw",
        })
        this.clearAddress()
      },
      payload
    )
  }

  renderDeliveryAutocompleteStuff() {
    if (this.state.pickup_or_delivery !== "delivery") return null
    const hasError =
      Boolean(this.state.errorMessage) && Boolean(this.state.addressObj) // Must have address to show an error
    return (
      <div>
        <div className="header-row-autocomplete-section">
          <div
            style={{ paddingTop: "15px" }}
            ref={this.streetAddressRef}
            className="checkout-label"
          >
            Street Address
          </div>
          <div
            className={classnames(
              "header-row-autocomplete-container addressWrapper checkerAddressWrapper",
              {
                "addressWrapper--error": hasError,
              }
            )}
          >
            <div className="address-input-container">
              <GooglePlacesAutocomplete
                onChange={(add) => {
                  this.setState({ addressObj: null })
                }}
                onFocus={() => {
                  this.setState({ addressFocused: true }, () => {
                    if (this.state.isMobile && this.streetAddressRef.current) {
                      window.scroll(0, this.streetAddressRef.current.offsetTop)
                    }
                  })
                }}
                onBlur={() => this.setState({ addressFocused: false })}
                updateParent={this.updateParent}
                onParent={this.onParent}
                checkout={true}
                isHidden={false}
                ref={this.googlePlacesAutocompleteRef}
                address={this.state.addressObj}
                formattedAddress={
                  this.state.addressObj
                    ? this.state.addressObj.formattedAddress
                    : ""
                }
                updateError={() => {
                  alert("error")
                }}
                onSelect={this.geocodeSelect.bind(this)}
                currentLocation={() => this.currentLocation()}
                isLoading={this.state.loading_gps}
                handleAddressBackspace={() => this.handleAddressBackspace()}
              />
              {this.renderLocationButton()}
            </div>
            {hasError && (
              <p className="autocompleteError">{this.state.errorMessage}</p>
            )}
          </div>
        </div>

        <div className="header-row-address2-section">
          <div className="checkout-label">Apartment # (Optional)</div>
          <div className="header-row-address2-input-wrapper">
            <input
              className="header-input"
              value={this.state.address2}
              onChange={(e) => {
                this.setState({ address2: e.target.value })
              }}
              onFocus={() => {
                this.setState({ addressFocused: true })
              }}
              onBlur={() => this.setState({ addressFocused: false })}
              placeholder="#2 APT C, Unit 203"
            />
          </div>
        </div>
      </div>
    )
  }

  readyToCheckout() {
    return (
      this.props.cart.savedCard ||
      (this.props.cart.sol && this.props.cart.walletConnected) ||
      (this.props.cart.sol && this.props.cart.qr) ||
      this.props.cart.applePay ||
      this.props.cart.bitcoin ||
      this.props.cart.foodcoin ||
      this.props.cart.addCardScreenOpen ||
      this.props.cart.cash ||
      this.state.zipcode.length === 5 ||
      (this.props.cart.finance.total === 0 && this.props.cart.finance.promo) ||
      (this.props.cart.supperclubWallet &&
        this.props.cart.remainingBalance === 0) ||
      (this.props.cart.customPayment &&
        this.state.customPaymentNumber &&
        this.state.customPaymentName &&
        this.state.customPaymentNumber.length == 7) ||
      window.KIOSK_MODE
    )
  }

  isUpdateEnabled() {
    if (!this.props.rest.hours) {
      return false
    }
    if (this.state.pickup_or_delivery === "delivery") {
      if (!this.state.addressObj) return false
    }
    if (!this.props.rest.hours[this.state.pickup_or_delivery]) return false

    if (this.props.rest.hours[this.state.pickup_or_delivery].open) return true
    else {
      if (
        this.timeSelectRef.current &&
        this.timeSelectRef.current.state.time &&
        this.timeSelectRef.current.state.time > 0
      ) {
        return true
      } else {
        return false
      }
    }
  }

  renderDropdownModal() {
    if (this.props.rest.isLocked()) return null

    let that = this
    if (this.state.headerExpansion || this.state.desktopChangeExpanded) {
      return (
        <div
          className="header-row-modal"
          ref={this.timeSelectDropdownRef}
          style={this.headerRowModalStyle()}
        >
          {this.renderCheckerPageStuff()}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TimeSelect
              key={this.state.pickup_or_delivery + "--timeselect"}
              currentPage="checkout"
              ref={this.timeSelectRef}
              delivery={false}
              updateParent={(time) => this.setState({ time: time })}
              pickup_or_delivery={this.state.pickup_or_delivery}
            />
          </div>

          {this.renderDeliveryAutocompleteStuff()}
          <div className="save-changes-button-container">
            <button
              style={{
                backgroundColor: this.props.rest.hex_color_primary,
                border: "0px solid white",
              }}
              className={classnames("header-row-save-changes-button", {
                "header-row-save-changes-button--disabled":
                  !this.isUpdateEnabled(),
              })}
              onClick={() => {
                if (this.state.pickup_or_delivery === "pickup") {
                  this.props.cart.setPickup()
                  this.timeSelectRef.current.saveToCart()
                  this.setState({
                    headerExpansion: null,
                    desktopChangeExpanded: false,
                  })
                } else if (this.state.pickup_or_delivery === "delivery") {
                  that.verifyDeliveryZone(that.state.addressObj)
                }
              }}
            >
              Update
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
              >
                <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />
              </svg>
            </button>
          </div>
        </div>
      )
    }
  }

  renderPickupDeliverySectionDesktop() {
    if (this.props.rest.isLocked()) return null
    return (
      <div className="pickup-delivery-container-desktop checkout-section">
        <div className="pickup-delivery-container-desktop-top-row">
          <div
            className="checkout-section-header"
            style={{ marginBottom: "0px" }}
          >
            {this.props.rest.name}
          </div>
          <div
            className="pickup-delivery-section-change-text"
            onClick={() =>
              this.setState({
                desktopChangeExpanded: !this.state.desktopChangeExpanded,
              })
            }
          >
            Change
          </div>
        </div>

        <div className="pickup-delivery-container-outer">
          <div>
            <div className="pickup-delivery-container-row-desktop">
              <div className="flex-row flex-start">
                <div className="pickup-delivery-icon-container" style={{}}>
                  {this.props.cart.pickup_or_delivery === "delivery" ? (
                    <DeliveryIcon />
                  ) : (
                    <PickupIcon />
                  )}
                </div>
                <div className="pickup-delivery-text">
                  {this.capitalize(this.props.cart.pickup_or_delivery)}
                </div>
              </div>
            </div>

            <div
              style={{ marginTop: "20px" }}
              className="pickup-delivery-container-row-desktop"
            >
              <div className="flex-row flex-start">
                <div className="pickup-delivery-icon-container">
                  <Clock />
                </div>
                <div className="pickup-delivery-text">
                  {this.props.cart.futureOrderTimeString()}
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.renderDropdownModal()}
      </div>
    )
  }

  renderPickupDeliverySectionMobile() {
    if (this.props.rest.isLocked()) return null
    return (
      <>
        <div
          style={window.KIOSK_MODE ? { pointerEvents: "none" } : {}}
          className="checkout-header-row"
          ref={this.headerRowRef}
        >
          <div
            className={classnames("pickup-delivery-container")}
            onClick={() => {
              this.setState({ headerExpansion: "order_type" })
            }}
          >
            <div className="pickup-delivery-icon-container">
              {this.props.cart.pickup_or_delivery === "delivery" ? (
                <div
                  style={{
                    transform: "scale(0.73, 0.73)",
                    position: "relative",
                    top: "2px",
                    right: "1px",
                  }}
                >
                  {" "}
                  <DeliveryIcon />{" "}
                </div>
              ) : (
                <PickupIcon />
              )}
            </div>
            <div className="pickup-delivery-text">
              {this.props.cart.pickup_or_delivery === "delivery"
                ? "Delivery"
                : "Pickup"}
            </div>
          </div>
          <div
            className={classnames("time-select-container")}
            onClick={() => {
              this.setState({ headerExpansion: "time_select" })
            }}
          >
            <div className="pickup-delivery-icon-container">
              <Clock />
            </div>
            <div>{this.props.cart.futureOrderTimeString()}</div>
          </div>
        </div>
        {this.renderDropdownModal()}
      </>
    )
  }

  renderPickupDeliverySection() {
    if (this.state.isMobile) return this.renderPickupDeliverySectionMobile()
    else return this.renderPickupDeliverySectionDesktop()
  }

  //we need the top to be the bottom of the top bar
  modalOverlayStyle() {
    if (this.headerRowRef.current) {
      let _top =
        this.headerRowRef.current.offsetTop +
        this.headerRowRef.current.offsetHeight
      return { top: _top + "px" }
    }
  }

  parseCustomTip() {
    if (this.state.isMobile) {
      let tip = this.state.customTipAmount
      if (tip) {
        this.props.cart.setTip(parseInt(tip))
      } else {
        this.props.cart.setTip(0)
      }
      this.setState({ tipModalOpen: false, customTipAmount: "" })
    } else {
      this.setState({ tipModalOpen: false })
      if (this.state.customTip === "") return
      let tip = Math.round(parseFloat(this.state.customTip) * 100)
      if (!tip && tip !== 0) alert("error")
      else this.props.cart.setTip(tip)
    }
  }

  filterCustomTipInput(value) {
    //check to see if they entered a valid $ amount into the input
    if (value.length && isNaN(parseFloat(value))) {
      //this.selectDefaultTipAmount()
      return
    }
    //strip non-numerical characters
    value = value.replace(/[^0-9.]/g, "")

    this.setState({ typing: true })

    if (value.length) {
      if (parseFloat(value) < 0) {
        alert("Tip must be positive!")
        return
      }

      if (
        parseFloat(value) === 0 &&
        this.props.cart.pickup_or_delivery === "delivery"
      ) {
        this.props.updateError(
          true,
          "Tips are appreciated & go to the driver. If selecting zero, we encourage a cash tip upon delivery",
          true,
          {
            zIndex: "1000",
            position: "fixed",
            top: "60px",
            width: "99vw",
            left: "0",
          }
        )
      }

      //don't allow multiple
      if ((value.match(/\./g) || []).length > 1) {
        return
      }

      //don't allow more than 2 numbers after the decimal
      if ((value.match(/\./g) || []).length === 1) {
        var idx = value.indexOf(".")
        if (idx + 4 <= value.length) {
          return
        }
      }

      //if they are typing in a period, then we don't want to parseFloat it
      var customTip = 0
      if (value.endsWith(".")) {
        customTip = value
      } else {
        //we need to set toFixed to be the amount after the decimal that's currently typed in
        //otherwise this code will make 3.40 into 3.4
        var period_idx = value.indexOf(".")
        if (period_idx > 0) {
          customTip = parseFloat(value).toFixed(value.length - 1 - period_idx)
        } else {
          customTip = parseFloat(value)
        }
      }

      this.setState({
        customTip: customTip,
      })
    } else {
      this.setState({ customTip: "", typing: false })
    }
  }

  renderTipModal() {
    if (!this.state.tipModalOpen) return null
    return (
      <Modal
        isOpen={this.state.tipModalOpen}
        onAfterOpen={() => {}}
        onRequestClose={() => {
          this.setState({ tipModalOpen: false })
        }}
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            backgroundColor: "#FAFAFA",
            padding: "0px",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
          },
        }}
        contentLabel="Example Modal"
      >
        <div className="checkout=custom-tip-modal">
          <div className="checkout-custom-tip-modal-top">
            <div>
              <div className="checkout-enter-tip-amount">Enter Tip Amount</div>
              {this.state.isMobile ? (
                <>
                  <div
                    className="checkout-custom-tip-input-fake"
                    onClick={() => this.customTipInputRef.current.focus()}
                  >
                    {this.renderCustomTipAmount()}
                  </div>
                  <div>
                    <input
                      autoFocus
                      value={this.state.customTipAmount}
                      ref={this.customTipInputRef}
                      inputmode="decimal"
                      className="checkout-custom-tip-input"
                      placeholder=""
                      type="number"
                      onKeyPress={(e) => {
                        if (e.charCode === 13) {
                          this.parseCustomTip()
                        }
                      }}
                      onChange={(e) => {
                        if (
                          e.target.value.match(/^-?\d+$/) ||
                          e.target.value === ""
                        ) {
                          this.setState({ customTipAmount: e.target.value })
                        }
                      }}
                    />
                  </div>
                </>
              ) : (
                <>
                  <span className="custom-tip-input-dollar-sign">$</span>
                  <input
                    autoFocus
                    value={this.state.customTip}
                    ref={this.customTipInputRef}
                    inputmode="decimal"
                    className="checkout-custom-tip-input"
                    placeholder=""
                    type="number"
                    onKeyPress={(e) => {
                      if (e.charCode === 13) {
                        this.parseCustomTip()
                      }
                    }}
                    onChange={(e) => this.filterCustomTipInput(e.target.value)}
                  />
                </>
              )}
            </div>
          </div>
          <div className="checkout-custom-tip-modal-bottom">
            <div
              onClick={() =>
                this.setState({
                  tipModalOpen: false,
                  customTip: null,
                  customTipAmount: "",
                })
              }
            >
              {" "}
              Cancel{" "}
            </div>
            <div
              className="checkout-custom-tip-ok"
              onClick={() => this.parseCustomTip()}
            >
              {" "}
              OK{" "}
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  renderFooter() {
    if (this.props.cart.bitcoin) {
      return (
        <div
          style={{ paddingLeft: "0px", paddingRight: "0px" }}
          className={classnames("checkout-footer-bitcoin", {
            "checkout-footer-mobile checkout-footer-mobile-bitcoin":
              this.state.isMobile,
          })}
        >
          <div
            onClick={() => this.submitOrderForProcessing()}
            className={classnames(
              "continue-with-bitcoin",
              "checkout-footer-bitcoin-button",
              { "checkout-footer-enabled-bitcoin": this.readyToCheckout() },
              { "checkout-footer-disabled-bitcoin": !this.readyToCheckout() }
            )}
          >
            <BitcoinCircle scale="0.6" width="23px" height="28px" />
            <div className="continue-with-bitcoin-text">
              Continue with Bitcoin
            </div>
          </div>
          {this.state.isMobile !== true && (
            <div className="bitcoin-wont-be-charged">
              You won't get charged yet
            </div>
          )}
        </div>
      )
    } else if (this.props.cart.applePay) {
      return (
        <div
          onClick={() => this.submitOrderForProcessing()}
          className={classnames(
            "checkout-footer",
            {
              "checkout-footer-mobile checkout-footer-mobile-applepay":
                this.state.isMobile,
            },
            {
              "checkout-footer-enabled checkout-footer-enabled-applepay":
                this.readyToCheckout(),
            },
            {
              "checkout-footer-disabled checkout-footer-disabled-applepay":
                !this.readyToCheckout(),
            }
          )}
        >
          <div>
            Check Out with &nbsp;
            <span style={{ position: "relative", top: "5px" }}>
              <ApplePayLogo />
            </span>
          </div>
        </div>
      )
    } else if (this.state.multiView == "reviewz") {
      return (
        <div
          onClick={() => this.setState({ multiView: "wallet" })}
          className={classnames(
            "checkout-footer",
            { "checkout-footer-mobile": this.state.isMobile },
            { "checkout-footer-enabled": this.readyToCheckout() },
            { "checkout-footer-disabled": !this.readyToCheckout() }
          )}
        >
          <div className="checkout-footer-left">
            <ShoppingCart />
            Continue to Wallet Balances
          </div>
          <div className="checkout-footer-right">
            {formatPrice.formatPrice(this.props.cart.finance.total)}
          </div>
        </div>
      )
    } else if (true) {
      return (
        <div
          onClick={() => this.submitOrderForProcessing()}
          className={classnames(
            "checkout-footer",
            { "checkout-footer-mobile": this.state.isMobile },
            { "checkout-footer-enabled": this.readyToCheckout() },
            { "checkout-footer-disabled": !this.readyToCheckout() }
          )}
        >
          <div className="checkout-footer-left">
            <ShoppingCart />
            Place {this.capitalize(this.props.cart.pickup_or_delivery)} Order
          </div>
          <div className="checkout-footer-right">
            {this.props.cart.supperclubWallet
              ? formatPrice.formatPrice(this.props.cart.remainingBalance)
              : formatPrice.formatPrice(this.props.cart.finance.total)}
          </div>
        </div>
      )
    } else {
      return (
        <div
          onClick={() => this.submitOrderForProcessing()}
          className={classnames(
            "checkout-footer",
            { "checkout-footer-mobile": this.state.isMobile },
            { "checkout-footer-enabled": this.readyToCheckout() },
            { "checkout-footer-disabled": !this.readyToCheckout() }
          )}
        >
          <div className="checkout-footer-left">
            <ShoppingCart />
            Scan Mobile Wallet
          </div>
          <div className="checkout-footer-right">
            {formatPrice.formatPrice(this.props.cart.finance.total)}
          </div>
        </div>
      )
    }
  }

  isCustomTipSelected() {
    if (!this.props.cart.finance.tip) return false
    for (var i in this.state.tipRates) {
      if (this.usePercent()) {
        if (
          Math.round(
            this.state.tipRates[i].percent * this.props.cart.subtotal()
          ) === this.props.cart.finance.tip
        ) {
          return false
        }
      } else {
        if (this.state.tipRates[i].amount === this.props.cart.finance.tip) {
          return false
        }
      }
    }
    return true
  }

  async createTransferTransactionUSDC(connection) {
    let total = this.props.cart.finance.total
    let dollars = total / 100
    let amount = dollars * 1000000

    //get the USDC address for the user
    let associatedDestinationTokenAddr =
      await splToken.getAssociatedTokenAddress(
        new PublicKey(USDC_ADDRESS),
        this.props.publicKey,
        false,
        new PublicKey(TOKEN_PROGRAM_ID),
        new PublicKey(ASSOCIATED_TOKEN_PROGRAM_ID)
      )

    let transaction = new Transaction().add(
      splToken.createTransferInstruction(
        associatedDestinationTokenAddr,
        new PublicKey(TREASURY_USDC_ADDRESS),
        this.props.publicKey,
        amount,
        [],
        TOKEN_PROGRAM_ID
      )
    )
    transaction.feePayer = this.props.publicKey
    const anyTransaction = transaction
    anyTransaction.recentBlockhash = (
      await connection.getRecentBlockhash()
    ).blockhash
    return transaction
  }

  // for each type of token in the cart, we need to create a txn
  // instruction accordingly
  async createTransaferInstruction(token, amount) {
    amount = parseInt(amount)
    if (token === "sol") {
      return SystemProgram.transfer({
        fromPubkey: this.props.publicKey,
        toPubkey: new PublicKey(TREASURY_ADDRESS),
        lamports: amount,
      })
    } else {
      let associatedDestinationTokenAddr
      let treasuryAddress
      let tokenAddress
      if (token === "usdc") {
        tokenAddress = USDC_TOKEN_ADDRESS
        treasuryAddress = TREASURY_USDC_ADDRESS
      } else if (token === "foodcoin") {
        tokenAddress = FOODCOIN_TOKEN_ADDRESS
        treasuryAddress = TREASURY_FOODCOIN_ADDRESS
      } else {
        alert("")
      }

      associatedDestinationTokenAddr = await splToken.getAssociatedTokenAddress(
        new PublicKey(tokenAddress),
        this.props.publicKey,
        false,
        new PublicKey(TOKEN_PROGRAM_ID),
        new PublicKey(ASSOCIATED_TOKEN_PROGRAM_ID)
      )

      let instruction = splToken.createTransferInstruction(
        associatedDestinationTokenAddr,
        new PublicKey(treasuryAddress),
        this.props.publicKey,
        amount,
        [],
        TOKEN_PROGRAM_ID
      )

      console.log("instruction", instruction)
      return instruction
    }
  }

  async createTransferTransaction(connection) {
    let total = this.props.cart.finance.total
    let sol = total / this.state.solPrice
    let lamports = sol * LAMPORTS_PER_SOL
    let transaction = new Transaction().add(
      SystemProgram.transfer({
        fromPubkey: this.props.publicKey,
        toPubkey: new PublicKey(TREASURY_ADDRESS),
        lamports: lamports,
      })
    )
    transaction.feePayer = this.props.publicKey
    const anyTransaction = transaction
    anyTransaction.recentBlockhash = (
      await connection.getRecentBlockhash()
    ).blockhash
    return transaction
  }

  async sendSupperClubPayment(amount) {
    const USDC_ADDRESS = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v"
    const FOODCOIN_ADDRESS = "B7vkWNFo2aYcYddtwR8fvDwY1Uc54wHfdTXULjrX7KeL"
    const TOKEN_PROGRAM_ID = "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
    const ASSOCIATED_TOKEN_PROGRAM_ID =
      "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"

    let connection = new Connection(window.RPC)

    let receipientSolanaPublicKey = new PublicKey(TREASURY_ADDRESS)
    let senderSolanaPublicKey =
      this.props.cart.supperclubWallet.keypair.publicKey
    let senderKeypair = this.props.cart.supperclubWallet.keypair

    let txn = new Transaction()

    for (var i = 0; i < this.props.cart.supperclubPromos.length; i++) {
      let payment = this.props.cart.supperclubPromos[i]
      if (payment.amount > 0) {
        let receipientFoodcoinAccountAddress =
          await splToken.getAssociatedTokenAddress(
            new PublicKey(payment.mint),
            receipientSolanaPublicKey,
            false,
            new PublicKey(TOKEN_PROGRAM_ID),
            new PublicKey(ASSOCIATED_TOKEN_PROGRAM_ID)
          )

        let senderFoodcoinAccountAddress =
          await splToken.getAssociatedTokenAddress(
            new PublicKey(payment.mint),
            senderSolanaPublicKey,
            false,
            new PublicKey(TOKEN_PROGRAM_ID),
            new PublicKey(ASSOCIATED_TOKEN_PROGRAM_ID)
          )

        txn.add(
          splToken.createTransferInstruction(
            senderFoodcoinAccountAddress,
            receipientFoodcoinAccountAddress,
            senderSolanaPublicKey,
            payment.amount,
            [],
            new PublicKey(TOKEN_PROGRAM_ID)
          )
        )
      }
    }

    for (var i = 0; i < this.props.cart.supperclubPayments.length; i++) {
      let payment = this.props.cart.supperclubPayments[i]
      if (payment.amount > 0) {
        let receipientFoodcoinAccountAddress =
          await splToken.getAssociatedTokenAddress(
            new PublicKey(payment.mint),
            receipientSolanaPublicKey,
            false,
            new PublicKey(TOKEN_PROGRAM_ID),
            new PublicKey(ASSOCIATED_TOKEN_PROGRAM_ID)
          )

        let senderFoodcoinAccountAddress =
          await splToken.getAssociatedTokenAddress(
            new PublicKey(payment.mint),
            senderSolanaPublicKey,
            false,
            new PublicKey(TOKEN_PROGRAM_ID),
            new PublicKey(ASSOCIATED_TOKEN_PROGRAM_ID)
          )

        txn.add(
          splToken.createTransferInstruction(
            senderFoodcoinAccountAddress,
            receipientFoodcoinAccountAddress,
            senderSolanaPublicKey,
            payment.amount,
            [],
            new PublicKey(TOKEN_PROGRAM_ID)
          )
        )
      }
    }

    txn.recentBlockhash = (await connection.getRecentBlockhash()).blockhash
    //txn.recentBlockhash = (await connection.getLatestBlockhash()).blockhash;
    txn.feePayer = senderSolanaPublicKey
    txn.sign(senderKeypair)

    let options = {
      commitment: "confirmed",
      skipPreflight: false,
      maxRetries: 20,
    }

    try {
      let sig = await sendAndConfirmTransaction(
        connection,
        txn,
        [senderKeypair],
        options
      )
      console.log("sig", sig)
      this.props.cart.setSolanaTxn(sig)
      this.props.cart.setWallet(senderSolanaPublicKey)
      //this.props.cart.selectPaymentNew("sol");
      this.sig = sig

      if (!sig) {
        return {
          success: 0,
          error: "unkown error",
        }
      }
    } catch (err) {
      console.log("signature error", err)
      return {
        success: 0,
        error: "unknown",
      }
    }
    return {
      success: 1,
    }
  }

  async sendTransaction() {
    var connection = new Connection(
      process.env.REACT_APP_SOLANA_RPC_ENDPOINT,
      "confirmed"
    )
    let transaction = new Transaction()
    for (let i in this.props.cart.solanaTokens) {
      let t = this.props.cart.solanaTokens[i]
      let instruction = await this.createTransaferInstruction(t.token, t.amount)
      transaction.add(instruction)
    }
    transaction.feePayer = this.props.publicKey
    const anyTransaction = transaction
    anyTransaction.recentBlockhash = (
      await connection.getRecentBlockhash()
    ).blockhash

    let signature = await this.props.sendTransaction(transaction, connection)
    console.log("signature", signature)
    try {
      let result = await waitForTxnToConfirm(signature)
      if (!result.success) {
        return {
          success: 0,
          error: result.error,
        }
      }
    } catch (err) {
      console.log("err2", err)
      return {
        success: 0,
        error: "unknown",
      }
    }
    //let signature = await connection.sendRawTransaction(signed.serialize());
    this.props.cart.setSolanaTxn(signature)
    return {
      success: 1,
    }
  }

  /*
  async sendTransaction(){
    let network =  clusterApiUrl("mainnet-beta")
    let connection = new Connection(network)
    let transaction
    if(this.props.cart.solanaToken === 'solana'){
      transaction = await this.createTransferTransaction(connection);
    } else if (this.props.cart.solanaToken === 'usdc'){
      transaction = await this.createTransferTransactionUSDC(connection);
    }
    //let signed = await window.solana.signTransaction(transaction);
    this.setState({loading:true})
    let signature = await this.props.sendTransaction(transaction, connection);
    console.log("signature", signature)
    try{
      let result = await waitForTxnToConfirm(signature) 
      if(!result.success){
        return {
          'success':0,
          'error':result.error
        }
      }
    } catch (err) {
      console.log("err2", err)  
      return {
        'success': 0,
        'error':'unknown'
      }
    }
    //let signature = await connection.sendRawTransaction(signed.serialize());
    this.props.cart.setSolanaTxn(signature)
    return {
      'success':1
    }
  }
*/

  renderDineIn() {
    if (this.props.rest.isLocked()) {
      return (
        <div className="special-instructions-section checkout-section">
          <div className="checkout-section-header">Table Number</div>
          <input
            value={this.props.cart.tableNumber}
            onChange={(e) => this.props.cart.setTableNumber(e.target.value)}
            className="header-input"
          />
        </div>
      )
    }
  }

  isTipSelected(rate) {
    if (this.usePercent()) {
      return (
        this.props.cart.finance.tip ===
        Math.round(rate.percent * this.props.cart.subtotal())
      )
    } else {
      return this.props.cart.finance.tip === rate.amount
    }
  }

  allowSplitTips() {
    return (
      this.props.cart.finance.tip > 500 &&
      this.props.rest.allowSplitTips &&
      this.props.cart.pickup_or_delivery === "delivery"
    )
  }

  secondaryColorAsRGBA() {
    if (!this.props.rest.hex_color_secondary) return

    function hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null
    }

    let rgb = hexToRgb(this.props.rest.hex_color_secondary)
    if (rgb) {
      let rgba = `rgb(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.1)`
      return rgba
    } else {
      return null
    }
  }

  renderSpecialInstructionsPlaceHolder() {
    if (this.state.specialInstructions === null) {
      return "Allergies, requests, instructions, etc.."
    }
  }

  renderDeliveryInstructionsPlaceHolder() {
    if (this.state.deliveryInstructions === null) {
      return "Leave at doorstep, call phone, etc..."
    }
  }

  modalStyle() {
    let style = {
      padding: "0px",
      width: "660px",
      height: "436px",
      "--rest-primary": this.props.rest.hex_color_primary,
      "--rest-secondary": this.props.rest.hex_color_secondary,
    }
    if (this.state.height > 600) {
      style["maxHeight"] = "calc(100vh - 80px) !important"
    }
    return style
  }

  // this used to do something. NOT ANYMORE!
  modalBackgroundStyle() {
    return {}
  }

  startQRSession() {
    Api.callApi(
      "qr-session-start",
      (data) => {
        this.setState({ qr_uuid: data.uuid }, () => this.poll())
      },
      (err) => {
        console.log(err)
      },
      { total: this.props.cart.finance.total }
    )
  }

  poll() {
    console.log("waffles inside poll")
    Api.callApi(
      "qr-session-check-txn",
      (resp) => {
        console.log("waffles", resp)
        if (resp.success) {
          // what do we do on success? we need to submit the order for
          // processing
          let sig = resp["signature"]
          this.props.cart.setSolanaTxn(sig)
          setTimeout(() => this.submitOrderForProcessing(), 1000)
        } else {
          setTimeout(() => this.poll(), 1000)
        }
      },
      (err) => {
        console.log("waffles err", err)
        setTimeout(() => this.poll(), 1000)
        console.log("error checking for qr session")
      },
      { uuid: this.state.qr_uuid }
    )
  }

  renderSolanaPayQR() {
    let url =
      window.API_HOST + "/api/qr-session-solana-pay?uuid=" + this.state.qr_uuid
    url = "solana:" + encodeURIComponent(url)

    return (
      <Modal2
        style={this.modalStyle()}
        backgroundStyle={this.modalBackgroundStyle()}
        close={() => this.setState({ solanaPayQR: false })}
        hideX={true}
      >
        <div className="qr-checkout-modal-container">
          <div className="qr-checkout-modal-left">
            <img src="https://cdn.hngr.co/supperclub/orderingcheckou.png" />
          </div>
          <div className="qr-checkout-modal-right">
            <div className="scan-to-pay">Scan to Pay</div>
            <div className="scan-to-pay-blurb">
              Scan code with your Mobile wallet.
              <br />
              <br />
              Your order will be processed when payment is confirmed.
            </div>
            <div className="scan-to-pay-qr-box">
              {this.state.qr_uuid ? (
                <QRCode size="160" value={url} />
              ) : (
                <div
                  style={{
                    width: "160px",
                    height: "160px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    style={{ width: "30px", height: "30px" }}
                    src="https://cdn.hngr.co/supperclub/roller2.gif"
                  />
                </div>
              )}
            </div>
            <div className="scan-qr-total">
              {formatPrice.formatPrice(this.props.cart.finance.total).substr(1)}{" "}
              FOOD
            </div>
          </div>
        </div>
      </Modal2>
    )
  }

  renderAppliedWallet() {
    if (
      !this.props.cart.supperclubWallet ||
      (!this.props.cart.supperclubPayments && !this.props.cart.supperclubPromos)
    ) {
      return null
    }

    let items = this.props.cart.supperclubDisplay.map(function (payment, i) {
      return (
        <div className="checkout-wallet-tokens-row">
          <div>
            <img src={payment.image} alt={payment.symbol} />
            {payment.name}
          </div>
          <div className="checkout-wallet-tokens-row-amount">
            -{formatPrice.formatPrice(payment.amount)}
          </div>
        </div>
      )
    })

    return (
      <div className="checkout-section">
        <div className="checkout-section-header">Wallet Balances</div>
        <div className="checkout-section-header-desc">
          Split your total payment between assets in your wallet and pay the
          difference
        </div>
        <div className="checkout-wallet-tokens">
          <div className="checkout-wallet-tokens-header">Wallet</div>
          {items}
        </div>
        <div className="checkout-wallet-remaining">
          <div className="checkout-wallet-remaining-row">
            Remaining amount due
            <div className="checkout-wallet-remaining-price">
              {formatPrice.formatPrice(this.props.cart.remainingBalance)}
            </div>
          </div>
          <div className="checkout-wallet-remaining-desc">
            Complete your order with card below
          </div>
        </div>
      </div>
    )
  }

  // this function redners the main strip of stuff... not the cart on the right
  renderCheckoutContent() {
    return (
      <div
        className="checkout-container"
        style={{
          "--rest-primary": this.props.rest.hex_color_primary,
          "--rest-secondary": this.props.rest.hex_color_secondary,
          "--rest-secondary-rgba-point1": this.secondaryColorAsRGBA(),
        }}
      >
        {this.renderPickupDeliverySection()}
        {/*this.renderDropdownModal()*/}
        <div
          onClick={this.closeModal}
          className={classnames("checkout-content")}
        >
          <Injection context={"CHECKOUT_PAGEVIEW"} />

          <div
            className="checkout-order-details-section checkout-section"
            ref={this.detailSectionRef}
          >
            {this.props.cart.pickup_or_delivery === "delivery" && (
              <>
                <div className="checkout-address-container">
                  <div>
                    <div className="checkout-section-header">Deliver To:</div>
                    {this.props.cart.confirmed_address && (
                      <>
                        <div className="checkout-address-line">
                          {this.props.cart.confirmed_address.address1}
                        </div>
                        <div className="checkout-address-line">
                          {`${this.props.cart.confirmed_address.city}, ${this.props.cart.confirmed_address.state} ${this.props.cart.confirmed_address.zipcode}`}
                        </div>
                      </>
                    )}
                  </div>
                  <div className="checkout-address-edit edit-text">
                    <div
                      onClick={(e) => {
                        e.stopPropagation()
                        this.setState({ headerExpansion: "order_type" })
                      }}
                    >
                      Edit
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: "30px" }}>
                  <div className="checkout-label">Apartment # (optional)</div>
                  <input
                    className="header-input"
                    value={
                      this.props.cart.confirmed_address
                        ? this.props.cart.confirmed_address.address2
                        : ""
                    }
                    onChange={(e) => {
                      let address = this.props.cart.confirmed_address
                      address["address2"] = e.target.value
                      this.props.cart.setConfirmedAddress(address)
                      this.setState({ address2: e.target.value })
                    }}
                    placeholder="#2 APT C, Unit 203"
                  />
                </div>

                <div style={{ marginTop: "30px" }}>
                  <div className="checkout-label">Delivery Instructions</div>
                  <span
                    style={{ backgroundColor: "white" }}
                    className={classnames("special-instructions-textarea", {
                      "placeholder-text":
                        this.state.deliveryInstructions === null,
                    })}
                    ref={this.deliveryInstructionRef}
                    onInput={(e) => {
                      this.setState(
                        {
                          deliveryInstructions:
                            this.deliveryInstructionRef.current.innerText,
                        },
                        () => {
                          let address = this.props.cart.confirmed_address
                          address["specialInstructions"] =
                            this.state.deliveryInstructions
                          this.props.cart.setConfirmedAddress(address)
                        }
                      )
                    }}
                    onClick={() => {
                      if (!this.state.deliveryInstructions) {
                        this.setState({ deliveryInstructions: "" }, () =>
                          this.deliveryInstructionRef.current.focus()
                        )
                      }
                    }}
                    role="textbox"
                    contenteditable=""
                  >
                    {this.renderDeliveryInstructionsPlaceHolder()}
                  </span>
                </div>
              </>
            )}

            {this.props.cart.pickup_or_delivery === "pickup" && (
              <div className="checkout-address-container">
                <div>
                  <div className="checkout-section-header">Pickup Location</div>
                  {this.props.rest.address && (
                    <>
                      <div className="checkout-address-line">
                        {this.props.rest.address}
                      </div>
                      <div className="checkout-address-line">
                        {`${this.props.rest.city}, ${this.props.rest.state} ${this.props.rest.zipcode}`}
                      </div>
                    </>
                  )}
                </div>
                <div className="checkout-address-edit edit-text"></div>
              </div>
            )}
          </div>

          {this.shouldShowTips() && (
            <div className="checkout-section">
              {!this.allowSplitTips() ? (
                <div className="checkout-section-header">Add a Tip</div>
              ) : (
                <div
                  className="checkout-section-header flex-row space-between"
                  style={{ marginBottom: "25px" }}
                >
                  <div>Add a Tip</div>
                  <div className="tip-total">
                    Total:{" "}
                    {formatPrice.formatPrice(this.props.cart.finance.tip)}
                  </div>
                </div>
              )}
              <div className="checkout-tip-container">
                {this.state.tipRates.map((rate) => (
                  <div
                    className={classnames(
                      "checkout-tip-outer",
                      { "checkout-tip-outer-mobile": this.state.isMobile },
                      { "checkout-tip-outer-desktop": !this.state.isMobile },
                      { "checkout-tip-selected": this.isTipSelected(rate) }
                    )}
                    onClick={() => {
                      if (this.usePercent()) {
                        this.props.cart.setTip(
                          Math.round(rate.percent * this.props.cart.subtotal())
                        )
                      } else {
                        this.props.cart.setTip(rate.amount)
                      }
                    }}
                  >
                    {this.usePercent() ? (
                      <div className="checkout-tip-inner-percent">
                        <div className="checkout-tip-percent-top">
                          {rate.percent * 100}%
                        </div>
                        <div className="checkout-tip-percent-bottom">
                          {formatPrice.formatPrice(
                            this.props.cart.subtotal() * rate.percent
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="checkout-tip-inner">
                        ${parseInt(rate.amount / 100)}
                      </div>
                    )}
                  </div>
                ))}

                {/* custom tip */}

                <div
                  className={classnames(
                    "checkout-tip-outer",
                    { "checkout-tip-outer-mobile": this.state.isMobile },
                    { "checkout-tip-outer-desktop": !this.state.isMobile },
                    { "checkout-tip-selected": this.isCustomTipSelected() }
                  )}
                  onClick={() => {
                    //we need to set customTip to whatever the current tip
                    //amount is
                    let customTip = ""
                    let customTipAmount = ""
                    // set the modal for desktop and mobile to show the
                    // custom tip amount
                    if (
                      this.props.cart.finance.tip &&
                      this.isCustomTipSelected()
                    ) {
                      let dollars = this.props.cart.finance.tip / 100
                      customTip = dollars.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                      })
                      customTip = customTip.substring(1)
                      customTipAmount = this.props.cart.finance.tip
                    }
                    this.setState({
                      tipModalOpen: true,
                      customTip: customTip,
                      customTipAmount: customTipAmount,
                    })
                  }}
                >
                  <div className="checkout-tip-inner">
                    {this.isCustomTipSelected() ? (
                      <>
                        {" "}
                        {formatPrice.formatPrice(
                          this.props.cart.finance.tip
                        )}{" "}
                      </>
                    ) : (
                      <>Custom</>
                    )}
                  </div>
                </div>
              </div>
              {this.allowSplitTips() && (
                <div ref={this.splitTipRef} className="flex-row space-between">
                  <div style={{ marginTop: "20px", maxWidth: "70%" }}>
                    <div className="sharing-is-caring checkout-section-subheader">
                      Sharing is Caring
                      <ToolTipQuestionMark
                        data-tip={`
                              <div style='width:250px'>
                                <div style='text-align:center; font-size:24px; font-weight:900; font-size:18px; margin-bottom:14px;'>How it Works</div>
                                <div style='font-size:15px; display:flex; flex-direction:row; justify-content:space-between;'>
                                  <div>Driver receives:</div>
                                  <div>$5.00</div>
                                </div>
                                <div style='font-size:15px; display:flex; flex-direction:row; justify-content:space-between;'>
                                  <div>Restaurant receives:</div>
                                  <div>${formatPrice.formatPrice(
                                    this.props.cart.finance.tip - 500
                                  )}</div>
                                </div>
                                <hr/>
                                <div style='font-size:15px; display:flex; flex-direction:row; justify-content:space-between;'>
                                  <div>Total Tip</div>
                                  <div>${formatPrice.formatPrice(
                                    this.props.cart.finance.tip
                                  )}</div>
                                </div>

                              </div>
                            `}
                        data-html="true"
                      />
                    </div>
                    <div>
                      Share the love &amp; give part of your gratuity towards
                      the kitchen staff
                    </div>
                  </div>
                  <div>
                    <Switch
                      onColor={this.props.rest.hex_color_primary}
                      onChange={() => {
                        this.setState({ splitTip: !this.state.splitTip }, () =>
                          this.props.cart.setSplitTip(this.state.splitTip)
                        )
                      }}
                      checked={this.state.splitTip}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      className="react-switch"
                    />
                  </div>
                </div>
              )}
            </div>
          )}

          {window.KIOSK_MODE && (
            <KioskDinerDetails ref={this.contactSectionRef} blue="yes" />
          )}

          {this.renderAppliedWallet()}

          {this.renderDineIn()}

          {!window.KIOSK_MODE &&
            ((this.props.cart.supperclubWallet &&
              this.props.cart.remainingBalance > 0) ||
              (!this.props.cart.supperclubWallet &&
                this.props.cart.finance.total > 0)) && (
              <div
                className="checkout-payment-section"
                ref={this.paymentSectionRef}
              >
                <CheckoutSelectPayment
                  solPrice={this.state.solPrice}
                  setLoading={this.setLoading}
                  unsetLoading={this.unsetLoading}
                  ref={this.checkoutSelectPaymentRef}
                  updateZipcode={(zip) => this.setState({ zipcode: zip })}
                  updateCustomPaymentNumber={(val) =>
                    this.setState({ customPaymentNumber: val })
                  }
                  updateCustomPaymentName={(val) =>
                    this.setState({ customPaymentName: val })
                  }
                  paymentError={this.state.paymentError}
                  clearPaymentError={() =>
                    this.setState({ paymentError: null })
                  }
                />
              </div>
            )}
        </div>

        <div className="checkout-flex-center">
          <div className="special-instructions-section checkout-section">
            <div className="checkout-section-header">Special Instructions</div>
            <span
              className={classnames("special-instructions-textarea", {
                "placeholder-text": this.state.specialInstructions === null,
              })}
              ref={this.specialInstructionRef}
              onInput={(e) => {
                this.setState(
                  {
                    specialInstructions:
                      this.specialInstructionRef.current.innerText,
                  },
                  () =>
                    this.props.cart.setSpecialInstructions(
                      this.state.specialInstructions
                    )
                )
              }}
              onClick={() => {
                if (!this.state.specialInstructions) {
                  this.setState({ specialInstructions: "" }, () =>
                    this.specialInstructionRef.current.focus()
                  )
                }
              }}
              role="textbox"
              contenteditable=""
            >
              {this.renderSpecialInstructionsPlaceHolder()}
            </span>
          </div>
        </div>

        {this.props.rest.offerNoUtensils && (
          <div className="checkout-flex-center">
            <div className="utensils-section checkout-section">
              <div className="checkout-section-header">
                Go Green
                <div className="leaf-container">
                  <Leaf />
                </div>
              </div>
              <div
                onClick={() =>
                  this.setState({ utensils: !this.state.utensils }, () =>
                    this.props.cart.setUtensils(this.state.utensils)
                  )
                }
                className="utensils-text-container"
              >
                <div>
                  <Checkbox checked={!this.state.utensils} />
                </div>
                <div className="utensils-text">
                  Do not include napkins and utensils
                </div>
              </div>
            </div>
          </div>
        )}

        {this.state.taxExemptEligible ? (
          <div className="checkout-flex-center">
            <div className="checkout-section">
              <div className="checkout-section-header">Tax Exempt</div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div onClick={() => this.toggleTaxExempt()}>
                  <Checkbox checked={this.state.taxExempt} />
                </div>
                <div style={{ marginLeft: "12px" }}>
                  I certify this order is for my organization and should be
                  exempt from sales tax.
                </div>
              </div>
            </div>
          </div>
        ) : null}

        {this.state.isMobile && (
          <div className="checkout-flex-center">
            <div
              ref={this.mobileCartSectionRef}
              className="cart-section checkout-section"
            >
              {this.state.cartError && (
                <div className="desktop-cart-error checkout-error-container">
                  <ErrorIcon />
                  <div style={{ paddingLeft: "15px" }}>
                    {this.state.cartError}
                  </div>
                </div>
              )}

              <div
                className="flex-row space-between"
                style={{ marginBottom: "15px" }}
              >
                <div
                  style={{ marginBottom: "0px" }}
                  className="checkout-section-header"
                >
                  Your Order ({this.props.cart.items.length})
                </div>
                <div
                  style={{ textDecoration: "underline" }}
                  onClick={this.editCart}
                  className="pickup-delivery-section-change-text"
                >
                  Edit Order
                </div>
              </div>
              <CartItems
                disable_edits={true}
                checkout={true}
                fontWeight="600"
              />
            </div>
          </div>
        )}

        <div className="checkout-flex-center">
          <div className="finance-section checkout-section">
            <div className="checkout-mobile-cart-container">
              <div className="checkout-mobile-cart-row">
                <div className="checkout-mobile-cart-key">Subtotal</div>
                <div className="checkout-mobile-cart-value">
                  {this.props.cart.supperclubWallet
                    ? formatPrice.formatPrice(
                        this.props.cart.finance.productTotal
                      )
                    : formatPrice.formatPrice(this.props.cart.finance.subtotal)}
                </div>
              </div>

              {this.props.cart.pickup_or_delivery === "delivery" && (
                <>
                  {this.props.cart.coupon &&
                  this.props.cart.coupon.coupon.action.indexOf(
                    "free_delivery"
                  ) > -1 ? (
                    <div
                      className="checkout-mobile-cart-row"
                      style={{ color: "#37b370" }}
                    >
                      <div className="checkout-mobile-cart-key">
                        Free Delivery with coupon{" "}
                        {this.props.cart.coupon.keycode}
                      </div>
                      <div className="checkout-mobile-cart-value">$0.00</div>
                    </div>
                  ) : (
                    <div className="checkout-mobile-cart-row">
                      <div className="checkout-mobile-cart-key">Delivery</div>
                      <div className="checkout-mobile-cart-value">
                        {formatPrice.formatPrice(
                          this.props.cart.deliveryFeeAfterPromo()
                        )}
                      </div>
                    </div>
                  )}
                </>
              )}

              {this.props.cart.finance.deliverySmallOrderFee ? (
                <div className="checkout-mobile-cart-row">
                  <div className="checkout-mobile-cart-key">
                    Small Order Charge
                  </div>
                  <div className="checkout-mobile-cart-value">
                    {formatPrice.formatPrice(
                      this.props.cart.finance.deliverySmallOrderFee
                    )}
                  </div>
                </div>
              ) : null}

              {this.props.cart.finance.deliveryServiceFee ? (
                <div className="checkout-mobile-cart-row">
                  <div className="checkout-mobile-cart-key taxes-and-fees-text">
                    Tax and Fees
                    <ToolTipQuestionMark
                      data-tip={`
                        <div>
                          <div style='font-weight:800; font-size:18px; margin-bottom:10px;'>Tax and Fees</div>
                          <table class='taxes-and-fees-tooltip-table'>
                            <tbody>
                              <tr>
                                <td>Tax</td>
                                <td>${formatPrice.formatPrice(
                                  this.props.cart.finance.tax
                                )}</td>
                              </tr>
                              <tr>
                                <td style='padding-right:50px;'>Service Fee</td>
                                <td>${formatPrice.formatPrice(
                                  this.props.cart.finance.deliveryServiceFee
                                )}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      `}
                      data-html="true"
                    />
                  </div>
                  <div className="checkout-mobile-cart-value">
                    {formatPrice.formatPrice(
                      this.props.cart.finance.tax +
                        this.props.cart.finance.deliveryServiceFee
                    )}
                  </div>
                </div>
              ) : (
                <div className="checkout-mobile-cart-row">
                  <div className="checkout-mobile-cart-key">Tax</div>
                  <div className="checkout-mobile-cart-value">
                    {formatPrice.formatPrice(this.props.cart.finance.tax)}
                  </div>
                </div>
              )}

              {/* we need a tooltip rendered without conditions for the taxes
                  and fees tooltip to work */}
              <span style={{ display: "none" }} data-tip=""></span>

              <div className="checkout-mobile-cart-row">
                <div className="checkout-mobile-cart-key">Tip</div>
                <div className="checkout-mobile-cart-value">
                  {formatPrice.formatPrice(this.props.cart.finance.tip)}
                </div>
              </div>

              {this.props.cart.finance.paymentMethodFees > 0 && (
                <div className="checkout-mobile-cart-row">
                  <div className="checkout-mobile-cart-key">
                    Card Processing Fee
                  </div>
                  <div className="checkout-mobile-cart-value">
                    {formatPrice.formatPrice(
                      this.props.cart.finance.paymentMethodFees
                    )}
                  </div>
                </div>
              )}

              {this.props.cart.finance.paymentMethodFees < 0 && (
                <div className="checkout-mobile-cart-row">
                  <div className="checkout-mobile-cart-key checkout-mobile-cart-discount">
                    Discount
                  </div>
                  <div className="checkout-mobile-cart-value checkout-mobile-cart-discount">
                    {formatPrice.formatPrice(
                      this.props.cart.finance.paymentMethodFees
                    )}
                  </div>
                </div>
              )}

              {this.props.cart.getIncentiveAmount("supperclubPromo") > 0 && (
                <div className="checkout-mobile-cart-row checkout-coupon-row">
                  <div className="checkout-mobile-cart-key">Promo Coins </div>
                  <div className="checkout-mobile-cart-value">
                    -
                    {formatPrice.formatPrice(
                      this.props.cart.getIncentiveAmount("supperclubPromo")
                    )}
                  </div>
                </div>
              )}
              {this.props.cart.coupon &&
                this.props.cart.coupon.coupon.action.indexOf("free_delivery") ==
                  -1 &&
                this.props.cart.getIncentiveAmount("coupon") > 0 && (
                  <div className="checkout-mobile-cart-row checkout-coupon-row">
                    <div className="checkout-mobile-cart-key">
                      Coupon {this.props.cart.coupon.keycode}
                    </div>
                    <div className="checkout-mobile-cart-value">
                      -
                      {formatPrice.formatPrice(
                        this.props.cart.getIncentiveAmount("coupon")
                      )}
                    </div>
                  </div>
                )}
              {this.props.cart.supperclubApplied > 0 && (
                <div className="checkout-mobile-cart-row checkout-coupon-row">
                  <div className="checkout-mobile-cart-key">Rest Coins </div>
                  <div className="checkout-mobile-cart-value">
                    -
                    {formatPrice.formatPrice(this.props.cart.supperclubApplied)}
                  </div>
                </div>
              )}

              {this.props.cart.finance.promo &&
              this.props.cart.coupon &&
              this.props.cart.coupon.is_nft_coupon ? (
                <div className="checkout-mobile-cart-row checkout-coupon-row">
                  <div className="checkout-mobile-cart-key">NFT COUPON</div>
                  <div className="checkout-mobile-cart-value">
                    -{formatPrice.formatPrice(this.props.cart.promoAmount())}
                  </div>
                </div>
              ) : null}

              <div className="checkout-mobile-cart-row mobile-cart-total-row">
                <div className="checkout-mobile-cart-key">Total</div>
                <div className="checkout-mobile-cart-value">
                  {this.props.cart.supperclubWallet
                    ? formatPrice.formatPrice(this.props.cart.remainingBalance)
                    : formatPrice.formatPrice(this.props.cart.finance.total)}
                </div>
              </div>
            </div>

            {this.props.cart.finance.paymentMethodFees < 0 && (
              <div className="debit-discount-applied">
                Debit Card Discount Applied
              </div>
            )}

            <br />
            <CouponInput checkoutPage={true} primary />
            {this.props.cart.coupon && !this.props.cart.coupon.is_nft_coupon ? (
              <div className="checkout-coupon-applied-container">
                <div className="checkout-coupon-applied-top">
                  Coupon {this.props.cart.coupon.keycode} applied!
                </div>
                <div
                  className="checkout-coupon-applied-remove"
                  onClick={() => this.props.cart.removeCoupon()}
                >
                  Remove
                </div>
              </div>
            ) : null}

            {this.props.cart.coupon && this.props.cart.coupon.is_nft_coupon ? (
              <div className="checkout-coupon-applied-container">
                <div className="nft-coupon-applied-bar">
                  <div>NFT Promo Applied</div>
                </div>
              </div>
            ) : null}

            {!this.state.isMobile && this.renderFooter("desktop_left")}
          </div>
        </div>

        {this.state.headerExpansion && (
          <div
            style={this.modalOverlayStyle()}
            className="modal-overlay"
            onClick={this.closeModal}
          ></div>
        )}

        {this.renderTipModal()}
        {this.state.isMobile && this.renderFooter()}

        {this.state.loading && (
          <div className="loading-overlay">
            <LoadingIndicator solana={this.props.cart.sol} />
          </div>
        )}
      </div>
    )
  }

  desktopCartStyle() {
    if (this.state.mounted && this.hiddenRightSideRef.current) {
      let t = this.hiddenRightSideRef.current.offsetTop
      let l = this.hiddenRightSideRef.current.offsetLeft + 10
      return {
        position: "fixed",
        left: l + "px",
        "--rest-primary": this.props.rest.hex_color_primary,
        "--rest-secondary": this.props.rest.hex_color_secondary,
      }
    } else {
      return { display: "none" }
    }
  }

  toggleTaxExempt() {
    this.setState({ taxExempt: !this.state.taxExempt }, () =>
      this.props.cart.setTaxExempt(this.state.taxExempt)
    )
  }

  renderCustomTipAmount() {
    let amount = this.state.customTipAmount
    if (amount.length === 0) {
      return "$0.00"
    } else if (amount.length == 1) {
      return "$0.0" + amount
    } else if (amount.length == 2) {
      return "$0." + amount
    } else if (amount.length === 3) {
      return "$" + amount[0] + "." + amount[1] + amount[2]
    } else {
      let integer = parseInt(amount)
      let num = integer / 100
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      })
      return formatter.format(num)
    }
  }

  renderKioskModal() {
    if (this.state.kioskModal) {
      return (
        <Modal
          isOpen={this.state.kioskModal}
          onAfterOpen={() => {}}
          onRequestClose={() => {
            this.setState({ tipModalOpen: false })
          }}
          style={{
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              zIndex: 999,
              backgroundColor: "#FAFAFA",
              padding: "0px",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
            },
          }}
          contentLabel="Example Modal"
        >
          <div className="checkout-kiosk-modal">
            <div className="checkout-kiosk-modal-header">
              {this.state.kioskModal !== "placed" && (
                <div
                  className="checkout-kiosk-modal-back"
                  onClick={async () => {
                    if (this.collectingPayment) {
                      await window.terminal.cancelCollectPaymentMethod()
                    }
                    this.setState({ kioskModal: null })
                  }}
                >
                  <Back />
                  <div>Back</div>
                </div>
              )}
            </div>

            {this.state.kioskModal === "loading" && (
              <>
                <div className="checkout-kiosk-modal-title">Loading...</div>

                <img src="https://cdn.hngr.co/kiosk-pay.png" height={0} />
              </>
            )}

            {this.state.kioskModal === "error" && (
              <>
                <div className="checkout-kiosk-modal-title">ERROR</div>
                <div>{this.state.kioskError.toString()}</div>
              </>
            )}

            {this.state.kioskModal === "placed" && (
              <>
                <div
                  className="checkout-kiosk-modal-title"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Success />
                  SUCCESS!
                </div>
                <br />
                <br />
                <div className="kiosk-success-center">
                  <div className="checkout-kiosk-modal-title">Order Number</div>
                  <div className="kiosk-order-number-box">
                    <div>{this.state.order.hash_id}</div>
                  </div>
                </div>

                <div className="self-destruct-message">
                  This message will self destruct in 30 seconds
                </div>

                <StartNewOrder
                  onClick={() => (window.location.href = "/")}
                  style={{ width: "200px" }}
                />
              </>
            )}

            {this.state.kioskModal === "ready_for_payment" && (
              <>
                <div className="checkout-kiosk-modal-title">
                  Swipe or tap to pay
                </div>

                <div className="">{this.state.kioskDisplayMessage}</div>

                <img
                  src="https://cdn.hngr.co/kiosk-pay.png"
                  alt="pay"
                  className="kiosk-modal-image"
                />

                <div style={{ fontSize: "30px", fontWeight: "bold" }}>
                  {formatPrice.formatPrice(this.props.cart.finance.total)}
                </div>
              </>
            )}
          </div>
        </Modal>
      )
    }
  }

  render() {
    if (this.state.isMobile) {
      return (
        <AppPage
          dont_load_contexts={true}
          {...this.props}
          hideCart
          disable_cart_edits
          fullpage
          footer
          footerClassName="legal-footer-checkout"
          back={() => this.props.history.goBack()}
        >
          <ReactTooltip />
          {this.renderKioskModal()}
          {this.renderCheckoutContent()}
        </AppPage>
      )
    } else {
      return (
        <AppPage
          dont_load_contexts={true}
          {...this.props}
          hideCart
          disable_cart_edits
          fullpage
          footer
          back={() => this.props.history.goBack()}
        >
          <ReactTooltip />

          {this.state.solanaPayQR && this.renderSolanaPayQR()}

          <div className="checkout-desktop-container">
            <div className="checkout-desktop-left">
              {this.renderCheckoutContent()}
            </div>
            <div
              ref={this.hiddenRightSideRef}
              className="hidden-right-side"
            ></div>
            <div
              ref={this.desktopCartRef}
              style={this.desktopCartStyle()}
              className="checkout-desktop-right"
            >
              <div className="checkout-section" style={{ marginTop: "18px" }}>
                <div className="checkout-desktop">
                  {this.state.cartError && (
                    <div className="desktop-cart-error checkout-error-container">
                      <ErrorIcon />
                      <div style={{ paddingLeft: "15px" }}>
                        {this.state.cartError}
                      </div>
                    </div>
                  )}

                  <div
                    className="flex-row space-between"
                    style={{ marginBottom: "15px" }}
                  >
                    <div
                      style={{ marginBottom: "0px" }}
                      className="checkout-section-header"
                    >
                      Your Order ({this.props.cart.items.length})
                    </div>
                    <div
                      style={{ textDecoration: "underline" }}
                      onClick={this.editCart}
                      className="pickup-delivery-section-change-text"
                    >
                      Edit Order
                    </div>
                  </div>
                  <CartItems disable_edits={true} checkout={true} />
                  {this.renderFooter("cart")}
                </div>
              </div>
            </div>
          </div>
        </AppPage>
      )
    }
  }
}

const Clock = (props) => (
  <svg
    style={{ fill: "white" }}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
  >
    <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 12v-6h-2v8h7v-2h-5z" />
  </svg>
)

const ShoppingCart = (props) => (
  <svg
    style={{ transform: "scale(-1,1)", fill: "white" }}
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 24 24"
  >
    <path d="M19.029 13h2.971l-.266 1h-2.992l.287-1zm.863-3h2.812l.296-1h-2.821l-.287 1zm-.576 2h4.387l.297-1h-4.396l-.288 1zm2.684-9l-.743 2h-1.929l-3.474 12h-11.239l-4.615-11h14.812l-.564 2h-11.24l2.938 7h8.428l3.432-12h4.194zm-14.5 15c-.828 0-1.5.672-1.5 1.5 0 .829.672 1.5 1.5 1.5s1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm5.9-7-.9 7c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5z" />
  </svg>
)

const Leaf = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
  >
    <path d="M15.787 7.531c-5.107 2.785-12.72 9.177-15.787 15.469h2.939c.819-2.021 2.522-4.536 3.851-5.902 8.386 3.747 17.21-2.775 17.21-11.343 0-1.535-.302-3.136-.92-4.755-2.347 3.119-5.647 1.052-10.851 1.625-7.657.844-11.162 6.797-8.764 11.54 3.506-3.415 9.523-6.38 12.322-6.634z" />
  </svg>
)

const ToolTipQuestionMark = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
  >
    <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1.25 17c0 .69-.559 1.25-1.25 1.25-.689 0-1.25-.56-1.25-1.25s.561-1.25 1.25-1.25c.691 0 1.25.56 1.25 1.25zm1.393-9.998c-.608-.616-1.515-.955-2.551-.955-2.18 0-3.59 1.55-3.59 3.95h2.011c0-1.486.829-2.013 1.538-2.013.634 0 1.307.421 1.364 1.226.062.847-.39 1.277-.962 1.821-1.412 1.343-1.438 1.993-1.432 3.468h2.005c-.013-.664.03-1.203.935-2.178.677-.73 1.519-1.638 1.536-3.022.011-.924-.284-1.719-.854-2.297z" />
  </svg>
)

const Back = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
  </svg>
)

const Success = (props) => (
  <svg
    {...props}
    clip-rule="evenodd"
    fill-rule="evenodd"
    stroke-linejoin="round"
    stroke-miterlimit="2"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m11.998 2.005c5.517 0 9.997 4.48 9.997 9.997 0 5.518-4.48 9.998-9.997 9.998-5.518 0-9.998-4.48-9.998-9.998 0-5.517 4.48-9.997 9.998-9.997zm0 1.5c-4.69 0-8.498 3.807-8.498 8.497s3.808 8.498 8.498 8.498 8.497-3.808 8.497-8.498-3.807-8.497-8.497-8.497zm-5.049 8.886 3.851 3.43c.142.128.321.19.499.19.202 0 .405-.081.552-.242l5.953-6.509c.131-.143.196-.323.196-.502 0-.41-.331-.747-.748-.747-.204 0-.405.082-.554.243l-5.453 5.962-3.298-2.938c-.144-.127-.321-.19-.499-.19-.415 0-.748.335-.748.746 0 .205.084.409.249.557z"
      fill-rule="nonzero"
    />
  </svg>
)

const StartNewOrder = (props) => (
  <svg
    {...props}
    width="644"
    height="97"
    viewBox="0 0 644 97"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M64 20.4826V40.3487C64 42.7892 62.0262 44.7634 59.5862 44.7634H39.7241C37.2841 44.7634 35.3103 42.7892 35.3103 40.3487C35.3103 37.9082 37.2841 35.934 39.7241 35.934H48.4676C44.3338 30.457 37.8124 27.135 30.8676 27.135C18.7172 27.135 8.82759 37.0239 8.82759 49.1781C8.82759 61.3323 18.7159 71.224 30.869 71.224C35.68 71.224 40.2524 69.7023 44.0938 66.8176C46.0552 65.3649 48.8138 65.7484 50.2745 67.6971C51.7352 69.6506 51.3434 72.418 49.3952 73.879C44.0117 77.9185 37.6214 80.0679 30.8848 80.0679C13.8621 80.0672 0 66.2023 0 49.1781C0 32.1539 13.8621 18.289 30.8828 18.289C40.4207 18.289 49.3655 22.7686 55.1724 30.1701V20.4826C55.1724 18.0421 57.1462 16.0679 59.5862 16.0679C62.0262 16.0679 64 18.0421 64 20.4826Z"
      fill="#1C1C1C"
    />
    <path
      d="M178.23 57.7159C178.23 60.0199 177.654 62.1532 176.502 64.1159C175.35 66.0359 173.643 67.5932 171.382 68.7879C169.12 69.9399 166.368 70.5159 163.126 70.5159C159.926 70.5159 157.067 69.9825 154.55 68.9159C152.032 67.8065 150.006 66.2279 148.47 64.1799C146.976 62.1319 146.123 59.7425 145.91 57.0119H155.51C155.723 58.8465 156.448 60.3825 157.686 61.6199C158.966 62.8145 160.651 63.4119 162.742 63.4119C164.619 63.4119 166.048 62.9212 167.03 61.9399C168.054 60.9159 168.566 59.6145 168.566 58.0359C168.566 56.6279 168.16 55.4759 167.35 54.5799C166.539 53.6412 165.515 52.8945 164.278 52.3399C163.04 51.7852 161.334 51.1452 159.158 50.4199C156.342 49.4812 154.038 48.5639 152.246 47.6679C150.454 46.7292 148.918 45.3852 147.638 43.6359C146.4 41.8865 145.782 39.6039 145.782 36.7879C145.782 32.9052 147.168 29.8545 149.942 27.6359C152.758 25.3745 156.47 24.2439 161.078 24.2439C165.856 24.2439 169.654 25.3959 172.47 27.6999C175.328 30.0039 176.95 33.0759 177.334 36.9159H167.606C167.35 35.2945 166.667 33.9719 165.558 32.9479C164.448 31.8812 162.934 31.3479 161.014 31.3479C159.35 31.3479 158.006 31.7959 156.982 32.6919C155.958 33.5452 155.446 34.8039 155.446 36.4679C155.446 37.7905 155.83 38.8999 156.598 39.7959C157.408 40.6492 158.411 41.3532 159.606 41.9079C160.843 42.4625 162.507 43.0812 164.598 43.7639C167.499 44.7879 169.846 45.7479 171.638 46.6439C173.472 47.5399 175.03 48.8839 176.31 50.6759C177.59 52.4679 178.23 54.8145 178.23 57.7159ZM203.821 62.3239V70.0679H199.085C195.117 70.0679 192.067 69.1079 189.933 67.1879C187.843 65.2679 186.797 62.0679 186.797 57.5879V42.2279H181.869V34.6119H186.797V25.8439H195.821V34.6119H203.757V42.2279H195.821V57.7159C195.821 59.4225 196.163 60.6172 196.845 61.2999C197.528 61.9825 198.68 62.3239 200.301 62.3239H203.821ZM224.203 34.1639C227.189 34.1639 229.749 34.8679 231.883 36.2759C234.016 37.6839 235.531 39.5825 236.427 41.9719V34.6119H245.387V70.0679H236.427V62.6439C235.531 65.0332 234.016 66.9532 231.883 68.4039C229.749 69.8119 227.189 70.5159 224.203 70.5159C221.216 70.5159 218.528 69.7905 216.139 68.3399C213.749 66.8892 211.872 64.7985 210.507 62.0679C209.184 59.2945 208.523 56.0519 208.523 52.3399C208.523 48.6279 209.184 45.4065 210.507 42.6759C211.872 39.9025 213.749 37.7905 216.139 36.3399C218.528 34.8892 221.216 34.1639 224.203 34.1639ZM227.019 42.0359C224.203 42.0359 221.941 42.9532 220.235 44.7879C218.528 46.6225 217.675 49.1399 217.675 52.3399C217.675 55.5399 218.528 58.0572 220.235 59.8919C221.941 61.6839 224.203 62.5799 227.019 62.5799C229.749 62.5799 231.989 61.6625 233.739 59.8279C235.531 57.9505 236.427 55.4545 236.427 52.3399C236.427 49.1825 235.531 46.6865 233.739 44.8519C231.989 42.9745 229.749 42.0359 227.019 42.0359ZM262.589 41.3959C263.911 39.1345 265.661 37.3639 267.837 36.0839C270.013 34.7612 272.445 34.0999 275.133 34.0999V43.7639H272.509C265.895 43.7639 262.589 46.8359 262.589 52.9799V70.0679H253.565V34.6119H262.589V41.3959ZM299.071 62.3239V70.0679H294.335C290.367 70.0679 287.317 69.1079 285.183 67.1879C283.093 65.2679 282.047 62.0679 282.047 57.5879V42.2279H277.119V34.6119H282.047V25.8439H291.071V34.6119H299.007V42.2279H291.071V57.7159C291.071 59.4225 291.413 60.6172 292.095 61.2999C292.778 61.9825 293.93 62.3239 295.551 62.3239H299.071ZM340.622 34.0999C344.718 34.0999 347.982 35.4439 350.414 38.1319C352.846 40.8199 354.062 44.5959 354.062 49.4599V70.0679H345.102V50.4839C345.102 47.6679 344.377 45.4919 342.926 43.9559C341.476 42.3772 339.492 41.5879 336.974 41.5879C334.414 41.5879 332.366 42.4199 330.83 44.0839C329.294 45.7479 328.526 48.1372 328.526 51.2519V70.0679H319.502V34.6119H328.526V41.7159C329.465 39.3265 331.001 37.4705 333.134 36.1479C335.31 34.7825 337.806 34.0999 340.622 34.0999ZM395.346 50.9959C395.346 51.8919 395.24 52.9159 395.026 54.0679H369.042C369.17 57.2252 370.024 59.5505 371.602 61.0439C373.181 62.5372 375.144 63.2839 377.49 63.2839C379.581 63.2839 381.309 62.7719 382.674 61.7479C384.082 60.7239 384.978 59.3372 385.362 57.5879H394.898C394.429 60.0625 393.426 62.2812 391.89 64.2439C390.354 66.2065 388.37 67.7425 385.938 68.8519C383.549 69.9612 380.882 70.5159 377.938 70.5159C374.482 70.5159 371.41 69.7905 368.722 68.3399C366.034 66.8465 363.944 64.7345 362.45 62.0039C360.957 59.2732 360.21 56.0519 360.21 52.3399C360.21 48.6279 360.957 45.4065 362.45 42.6759C363.944 39.9025 366.034 37.7905 368.722 36.3399C371.41 34.8892 374.482 34.1639 377.938 34.1639C381.437 34.1639 384.488 34.8892 387.09 36.3399C389.736 37.7905 391.762 39.7959 393.17 42.3559C394.621 44.8732 395.346 47.7532 395.346 50.9959ZM386.258 50.0999C386.386 47.1985 385.618 45.0012 383.954 43.5079C382.333 42.0145 380.328 41.2679 377.938 41.2679C375.506 41.2679 373.458 42.0145 371.794 43.5079C370.13 45.0012 369.213 47.1985 369.042 50.0999H386.258ZM452.504 34.6119L442.968 70.0679H432.984L425.368 44.2759L417.56 70.0679H407.576L398.104 34.6119H407.128L412.888 62.0039L420.76 34.6119H430.296L438.232 62.0039L444.056 34.6119H452.504ZM487.324 34.1639C490.78 34.1639 493.873 34.8892 496.604 36.3399C499.377 37.7905 501.553 39.9025 503.132 42.6759C504.71 45.4065 505.5 48.6279 505.5 52.3399C505.5 56.0519 504.71 59.2732 503.132 62.0039C501.553 64.7345 499.377 66.8465 496.604 68.3399C493.873 69.7905 490.78 70.5159 487.324 70.5159C483.868 70.5159 480.753 69.7905 477.98 68.3399C475.249 66.8465 473.094 64.7345 471.516 62.0039C469.937 59.2732 469.148 56.0519 469.148 52.3399C469.148 48.6279 469.937 45.4065 471.516 42.6759C473.094 39.9025 475.249 37.7905 477.98 36.3399C480.753 34.8892 483.868 34.1639 487.324 34.1639ZM487.324 41.9719C484.806 41.9719 482.673 42.8679 480.924 44.6599C479.174 46.4092 478.3 48.9692 478.3 52.3399C478.3 55.7105 479.174 58.2919 480.924 60.0839C482.673 61.8332 484.806 62.7079 487.324 62.7079C489.841 62.7079 491.974 61.8332 493.724 60.0839C495.473 58.2919 496.348 55.7105 496.348 52.3399C496.348 48.9692 495.473 46.4092 493.724 44.6599C491.974 42.8679 489.841 41.9719 487.324 41.9719ZM520.901 41.3959C522.224 39.1345 523.973 37.3639 526.149 36.0839C528.325 34.7612 530.757 34.0999 533.445 34.0999V43.7639H530.821C524.208 43.7639 520.901 46.8359 520.901 52.9799V70.0679H511.877V34.6119H520.901V41.3959ZM552.328 34.1639C555.314 34.1639 557.853 34.8679 559.944 36.2759C562.077 37.6839 563.613 39.5825 564.552 41.9719V22.7079H573.512V70.0679H564.552V62.6439C563.613 65.0332 562.077 66.9532 559.944 68.4039C557.853 69.8119 555.314 70.5159 552.328 70.5159C549.341 70.5159 546.653 69.7905 544.264 68.3399C541.874 66.8892 539.997 64.7985 538.632 62.0679C537.309 59.2945 536.648 56.0519 536.648 52.3399C536.648 48.6279 537.309 45.4065 538.632 42.6759C539.997 39.9025 541.874 37.7905 544.264 36.3399C546.653 34.8892 549.341 34.1639 552.328 34.1639ZM555.144 42.0359C552.328 42.0359 550.066 42.9532 548.36 44.7879C546.653 46.6225 545.8 49.1399 545.8 52.3399C545.8 55.5399 546.653 58.0572 548.36 59.8919C550.066 61.6839 552.328 62.5799 555.144 62.5799C557.874 62.5799 560.114 61.6625 561.864 59.8279C563.656 57.9505 564.552 55.4545 564.552 52.3399C564.552 49.1825 563.656 46.6865 561.864 44.8519C560.114 42.9745 557.874 42.0359 555.144 42.0359ZM615.034 50.9959C615.034 51.8919 614.927 52.9159 614.714 54.0679H588.73C588.858 57.2252 589.711 59.5505 591.29 61.0439C592.868 62.5372 594.831 63.2839 597.178 63.2839C599.268 63.2839 600.996 62.7719 602.362 61.7479C603.77 60.7239 604.666 59.3372 605.05 57.5879H614.586C614.116 60.0625 613.114 62.2812 611.578 64.2439C610.042 66.2065 608.058 67.7425 605.626 68.8519C603.236 69.9612 600.57 70.5159 597.626 70.5159C594.17 70.5159 591.098 69.7905 588.41 68.3399C585.722 66.8465 583.631 64.7345 582.138 62.0039C580.644 59.2732 579.898 56.0519 579.898 52.3399C579.898 48.6279 580.644 45.4065 582.138 42.6759C583.631 39.9025 585.722 37.7905 588.41 36.3399C591.098 34.8892 594.17 34.1639 597.626 34.1639C601.124 34.1639 604.175 34.8892 606.778 36.3399C609.423 37.7905 611.45 39.7959 612.858 42.3559C614.308 44.8732 615.034 47.7532 615.034 50.9959ZM605.946 50.0999C606.074 47.1985 605.306 45.0012 603.642 43.5079C602.02 42.0145 600.015 41.2679 597.626 41.2679C595.194 41.2679 593.146 42.0145 591.482 43.5079C589.818 45.0012 588.9 47.1985 588.73 50.0999H605.946ZM630.464 41.3959C631.786 39.1345 633.536 37.3639 635.712 36.0839C637.888 34.7612 640.32 34.0999 643.008 34.0999V43.7639H640.384C633.77 43.7639 630.464 46.8359 630.464 52.9799V70.0679H621.44V34.6119H630.464V41.3959Z"
      fill="black"
    />
  </svg>
)

export default withWallet(
  withRouter(
    withErrorHandling(
      injectStripe(
        withRouter(
          AnalyticsContextHOC(
            CartContextHOC(UserContextHOC(EntryPointHOC(Checkout)))
          )
        )
      )
    )
  )
)
